import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { Row, Col, Form, Input, Select, Upload, message, DatePicker, Spin, Table, Space, Drawer, Modal, Popover } from 'antd';
import PropTypes from 'prop-types';
import ImgCrop from 'antd-img-crop';
import "moment-timezone";
import moment from 'moment';
import { Scrollbars } from 'react-custom-scrollbars';
import { PlusCircleOutlined, InfoCircleOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import FeatherIcon from 'feather-icons-react';
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import InitialData from './InitialData.json'
import DetailsPage from './DetailsPage/Detailspage';
import DealFields from './DetailsPage/DealDetailsFields'
import RelatedTab from './DetailsPage/RelatedTab'
import DealRightData from './DetailsPage/DealRightData'
import DealStatusBar from './DetailsPage/DealStatusBar'
import PipelineStagesArrow from './DetailsPage/PipelineStages'
import AddTaskPage from './AddTask'
import { UploadUserTag, UserOwnerDetails } from './GlobalComponents/UserCardCmnts'
import { AccountDetails, DealDetails, TaskRelatedItem, TaskRelatedItem1 } from './GlobalComponents/OtherCardCmnts'
import { RelatedDocUpload } from './GlobalComponents/RelatedDocUpload'
import QuotesAdd from '../QISC/QuotesAdd'
import { setEditCall, setExPoCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { AccountsByAccountType, FetchAllAccount } from '../../../Api/Services/AccountApiService';
import { FetchDealByAccount, FetchDealDetails, FetchAllPipeline, PriorityDealApi, DealTypeAPi, DealUpdate, createDeals, wonReasonApi, LostReasonApi, HoldReasonapi, } from '../../../Api/Services/DealApiService';
import { getAllUsersData, getBussinesDaysForStaffRole } from '../../../Api/Services/CommonApiService'
import { getProjectList, getProductDetails } from '../../../Api/Services/Productapiservice'
import { FetchAllServiceLines } from '../../../Api/Services/ServiceLineApiService'
import { findAllStaffRoleByReportingUser, getByAddStaffRoleId } from '../../../Api/Services/StaffRoleApiService'
import { FetchContactDetails, FetchContactByAccount } from '../../../Api/Services/ContactApiService';
// import { PageHeader } from '../../../components/page-headers/page-headers';
import { Main, BasicFormWrapper, VerticalFormStyleWrap } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import { convertCurrency, ExchangeCurrency, useExcryptedNavigation, useNavigationDecrypted } from '../Filters/FilterConditions';
import { getBaseURL } from '../../../Api/ApiConfig'
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import Approvaldialog from '../Popup/Approvaldialog'
import Popup from '../Popup/DEMassPopup'
import CallLogPopup from '../Popup/CallLogPopup'
import NotesPopup from '../Popup/NotesPopup';
import Data from '../MassupdateJson/InLineEditFields.json';
import { ShareIcon, CallLogIcon, EmailIcon, CalendarIcon, TaskIcon, NotesIcon, CloneIcon, QuotesIcon, SaveIcon, CancelIcon, DeleteIcon, ChangeOwnerIcon } from '../../../components/Icons/Icons';
import ComposeMail from '../Email/Compose';
import AllCancelPopup from '../Popup/AllCancelPopup';
import MeetingLiPopup from '../Popup/MeetingLiPopup'
import SharePopup from '../Popup/SharePopup'
import { nameOnChangeValidator, validateDescriptionField } from '../../../components/utilities/utilities';

const { Option } = Select;

function AddNew({ UrlId, FromPage, setCratePage, GetAll, dataForDeal, CallBackTrigger, ShortCut }) { // dataForDeal
    const DealprevValues = useRef({ UrlId: "", FromPage: "" });
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const { emailapiValues, emailactiontype } = useSelector((state) => state.EmailData);
    const dispatch = useDispatch();
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const defaultCurrency = localData.currency
    const permission = localData.permissions
    const Role = localData.role
    const companyProfile = localData.company
    const history = useHistory();
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const currentDate = new Date(currentrealTime);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    const hours = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const formattedTime = `${hours}:${minutes}`;
    const [form] = Form.useForm();
    const [trigger, setTrigger] = useState()
    const [users, setUsers] = useState([])
    const [dealInitial, setDealInitial] = useState()
    const [tempWinProp, setTempWinProp] = useState()
    const [edit, setEdit] = useState(false)
    const [editWon, setEditWon] = useState(false)
    const [approveCondition, setApproveCondition] = useState(false)
    const [account, setAccount] = useState([])
    const [accountbyType, setAccountbyType] = useState([])
    const [FILEList, setFileList] = useState([]);
    const [dealPriority, setDealPriority] = useState([])
    const [dealType, setDealType] = useState([])
    const [dealWon, setDealWon] = useState([])
    const [createPageTask, setCreatePageTask] = useState()
    const [dealLose, setDealLose] = useState([])
    const [dealMapList, setDealMapList] = useState([])
    const [dealOnHold, setDealOnHold] = useState([])
    const [pipeLineStage, setPipelineStage] = useState([])
    // const [companyId, setCompayId] = useState()
    const [editField, setEditField] = useState(false)
    const [pipelineData, setPipelineData] = useState()
    const [pipeLineField, setPipeLineField] = useState()
    const [drawerPage, setDrawerPage] = useState()
    const [dealTypeData, setDealTypeData] = useState()
    const [dealTypeField, setDealTypeField] = useState()
    const [typeAction, setTypeAction] = useState()
    const [productdata, setProductdata] = useState([])
    const [contacts, setContacts] = useState([])
    const [dealId, setDealId] = useState()
    const [displayData, setDisplayData] = useState()
    const [dealDetailsData, setDealDetailsData] = useState()
    const [winProbability, setWinProbability] = useState()
    const [dealDiscount, setDealDiscount] = useState()
    const [serviceLineData, setServiceLineData] = useState([])
    const [action, setAction] = useState()
    const [assignOwner, setAssignOwner] = useState()
    const [notePopup, setNotePopup] = useState(false)
    const [dealIDs, setDealIDs] = useState()
    const [updatePopup, setUpdatePopup] = useState(false)
    const [popupType, setPopupType] = useState()
    const [callLogPopup, setCallLogPopup] = useState(false)
    const [NacTrigger, setNaCTrigger] = useState()
    const [expectedClosureDate, setExpectedClosureDate] = useState(null)
    const [revenueStartDate, setRevenueStartDate] = useState(null)
    const [revenueEndDate, setRevenueEndDate] = useState(null)
    const [actualclosureDate, setActualclosureDate] = useState(null)
    const [dealLostDate, setDealLostDate] = useState(null)
    const [approveOpen, setApproveOpen] = useState(false)
    const [dealonholdDate, setDealonholdDate] = useState(null)
    const [dealrestartDate, setDealrestartDate] = useState(null)
    const [dealValueEdit, setDealValueEdit] = useState()
    const [pipelineV, setPipelineV] = useState()
    const [editableType, setEditableType] = useState(false)
    const [mailOpen, setMailOpen] = useState(false)
    const [oldPipeline, setOldPipeline] = useState()
    const [OldFixed, setOldFixed] = useState()
    const [page, setPage] = useState()
    const [image, setImage] = useState()
    const [deleteOption, setDeleteOpen] = useState(false);
    const [taskProp, setTaskProp] = useState()
    const [taskPage] = useState("AddPage")
    const [pages] = useState("Meeting")
    const [popupMessage, setPopupMessage] = useState(false)
    const [meetingOpen, setMeetingOpen] = useState(false)
    const [staffRoleData, setStaffRoleData] = useState([])
    const [contactIds, setConatctIds] = useState([])
    const [meetingAttendees, setMeetingAttendees] = useState([])
    const [emailAttendees, setEmailAttendees] = useState([])
    const [permissions] = useState(permission.entity)
    const [sharePopup, setSharePopup] = useState(false)
    const [dealValues, setDealValue] = useState(0)
    const [totalDeal, setTotalDeal] = useState(0)
    const [dataPermissions, setDataPermissions] = useState()
    const [currencySettings, setCurrencySetting] = useState()
    const currencySettingsRef = useRef(currencySettings);
    const [changeDealMargin, setChangeDealMargin] = useState()
    const [changeDealMargin2, setChangeDealMargin2] = useState()
    const [createPageQuote, setCratePageQuote] = useState()
    const [uiReady, setUiReady] = useState(false)
    const [dataForQuote, setDataForQuote] = useState()
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [errorData, setErrorData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const ConvertRate = currencySettings?.exchangeRate;
    const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const [deleteClick, setDelteClick] = useState(false)
    const scroolup = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
            const scrollStep = Math.max(1, Math.ceil(currentPosition / 20));
            window.scrollTo(0, currentPosition - scrollStep);
            requestAnimationFrame(scroolup);
        }
    }
    const PageCancel = () => {
        history.push('/Home/proposals')
    }
    const normalizeValue = (value) => {
        if (value === undefined || value === "") return null;
        return value;
    };
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };
    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };
    const formattedCurrentDate = currentDate.toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' });
    const RequiredDateFormating = (dateString) => {
        const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
        const formattedDate = parsedDate.format("YYYY-MM-DD");
        return formattedDate;
    }
    const formatDateString = (dateString, format) => {
        return moment(dateString, "YYYY-MM-DD").format(format);
    };
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }
    // Create
    const canCreate = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        return hasRolePermission;
    };
    // Share
    const canShare = (dataPermissions, action) => {
        if (!dataPermissions) return false;
        const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
        const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
        return hasDataPermission;
    };
    // Update/Delete
    const canUpdateDelete = (rolePermissions, dataPermissions, action, actionRoleId) => {
        if (!Array.isArray(rolePermissions) || !dataPermissions) return false;
        const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
        return hasRolePermission && hasDataPermission;
    };
    const successMessage = (titles, data, type) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    {type === "Approve" ? <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> : <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />}
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => {
                modal.destroy();
                if (type === "Approve") {
                    // setTimeout(() => {
                    history.push('/Home/proposals')
                    // getData(dealId); // This runs after 2 seconds
                    // }, 1000);
                }
            }
        });
    }
    const [formDatas, setFormDatas] = useState([
        {
            dealProductId: null,
            productCategory: null,
            productLicenseSellingPriceUnitMonth: null,
            numberOfUnits: null,
            licenseDuration: null,
            total: '',
        },
    ]);
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const requiredFields = ['dealProductId', 'numberOfUnits', 'licenseDuration'];
    const isFormDataValid = formDatas.every(formData => {
        return requiredFields.every(field => {
            const value = formData[field];
            return value && value !== undefined && value !== '';
        });
    });
    const [servicesData, setServiceData] = useState([
        {
            serviceName: null,
            serviceLineId: null,
            serviceLineCost: null,
        },
    ]);
    const isservicesDataValid = servicesData.every(formData => {
        return Object.values(formData).every(value => value && value !== undefined && value !== '');
    });
    const [roleData, setRoleData] = useState([
        {
            addStaffRoleId: null,
            country: null,
            rolePerDayRate: null,
            startDate: null,
            endDate: null,
            totalValue: null,
        },
    ]);
    // const isroleDataValid = roleData.every(formData => {
    //     return Object.values(formData).every(value => value && value !== undefined && value !== '');
    // });
    const onnavigate = () => {
        history.push("/Home/email-config")
    }
    const CreateQuotes = (DeId, AcId) => {
        setNaCTrigger("trigger")
        setCratePageQuote("FromDeal")
        setDataForQuote({ DealId: DeId, AccountId: AcId, dealDetails: displayData })
    }
    async function getAllAccoutbyType() {
        try {
            const data = await AccountsByAccountType()
            setAccountbyType(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName?.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            let accountInfo = data;
            if (displayData?.account_id) {
                const isAlreadyIncluded = data?.some(contact => contact.account_id === displayData?.account_id);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, { account_name: displayData?.accountName, account_id: displayData?.account_id, account_type_name: "Customer" }];
                }
            }
            if (FromPage === "ContactPage" && dataForDeal) {
                const isAlreadyIncluded = data?.some(contact => contact.account_id === dataForDeal?.contactDetails?.account_id);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, { account_name: dataForDeal?.contactDetails?.account_name, account_id: dataForDeal?.contactDetails?.account_id, account_type_name: "Customer", account_number: dataForDeal?.contactDetails?.account_number, account_profile: dataForDeal?.contactDetails?.account_profile }];
                }
            }
            setAccount(accountInfo)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function PriorityApi() {
        try {
            const data = await PriorityDealApi()
            const options = data.map((option, i) => (
                <Option value={option.priorityId} key={i} >
                    {option.priorityName}
                </Option>));
            setDealPriority(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function DealTypeApi() {
        try {
            const data = await DealTypeAPi()
            setDealType(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function DealWonApi() {
        try {
            const data = await wonReasonApi()
            const options = data.map((option, i) => (
                <Option value={option.dealWonReasonId} key={i} >
                    {option.dealWonReasonName}
                </Option>));
            setDealWon(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function DealLoseApi() {
        try {
            const data = await LostReasonApi()
            const options = data.map((option, i) => (
                <Option value={option.dealLostReasonId} key={i} >
                    {option.dealLostReasonName}
                </Option>));
            setDealLose(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function DealOnHoldApi() {
        try {
            const data = await HoldReasonapi()
            const options = data.map((option, i) => (
                <Option value={option.dealHoldReasonId} key={i} >
                    {option.dealOnHoldReasonName}
                </Option>));
            setDealOnHold(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const formattedDate = converted.format(dateFormat);

        return formattedDate
    }
    async function deleteMenu(id) {
        setDealIDs([id])
        setUpdatePopup(true)
        setPopupType("Delete")
    }
    async function fetchAttendeeData(id) {
        try {
            const response = await FetchContactDetails(id);
            return response.data
        } catch (error) {
            message.error(error)
        }
    }
    const handleNoteClick = (value) => {
        setNotePopup(true)
        setPopupType(value)
        setNaCTrigger("trigger")
        setPage("Entity")
    }
    const handleCallLogClick = (value) => {
        setCallLogPopup(true)
        setPopupType(value)
        setNaCTrigger("trigger")
    }
    const AssignToFucntion = () => {
        if (approveCondition) { setApproveOpen(true) }
        else {
            setDealIDs([dealId])
            setUpdatePopup(true)
            setPopupType("Change Owner")
            setAction("SingleChangeOwner")
        }
    }
    const handlePipeLineChange = (value, option, winData, type) => {
        form.setFieldsValue({ pipelineStage: value })
        setPipelineData(value)
        setPipeLineField(option.key)
        if (type !== "Update") {
            if (option.key !== "Prospecting" && option.key !== "Qualification" && option.key !== "Discovery") {
                form.setFieldsValue({
                    commitstatus: "Soft Commit"
                })
            }
            else {
                form.setFieldsValue({
                    commitstatus: null
                })
            }
        }
        if (option.key !== "Won" && option.key !== "Lost") {
            form.setFieldsValue({
                dealWonreasons: undefined,
                deallostReasons: undefined
            });
        }
        if (option.key === "on-Hold" || option.key === "On-Hold" || option.key === "Lost") {
            setOldPipeline(OldFixed)
        } else {
            setOldPipeline(null)
        }
        if (option.key === "Won" || option.key === "Lost") {
            form.setFieldsValue({
                winProbability: option.key === "Won" ? "100" : "0"
            })
            setWinProbability(option.key === "Won" ? "100" : "0")
        } else {
            // eslint-disable-next-line no-lonely-if
            if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
                form.setFieldsValue({
                    winProbability: winData
                })
                setWinProbability(winData)
            }
        }
    }
    const handleAccountChange = async (value, rId) => {
        if (value) {
            try {
                const response = await FetchContactByAccount(value)
                const contactIds = (rId && rId !== "") ? rId?.split(',').map(id => id.trim()) : null
                const updatedContactList = response ? [...response] : [];
                if (contactIds?.length > 0) {
                    const missingIds = contactIds.filter(
                        id => !updatedContactList.some(
                            contact => String(contact.contacts_id) === String(id)
                        )
                    );
                    if (missingIds?.length > 0) {
                        try {
                            const responses = await Promise.all(
                                missingIds.map(id =>
                                    FetchContactDetails(id).catch(err => ({ error: err, id }))
                                )
                            );
                            const newContacts = responses
                                .filter(res => res && res.data && !res.error)
                                .map(res => res.data);
                            updatedContactList.push(...newContacts); // mutation is OK with const
                        } catch (err) {
                            message.error("Some contact details could not be fetched");
                        }
                    }
                }
                setContacts(updatedContactList);
            }
            catch (error) {
                message.error(error)
            }
        }
        if (value) {
            try {
                const DealList = await FetchDealByAccount(value)
                const updatedContactList = [...DealList];
                if (displayData?.parent_deal_id) {
                    const isAlreadyIncluded = updatedContactList.some(
                        deal => deal.deals_id === displayData.parent_deal_id
                    );
                    if (!isAlreadyIncluded) {
                        try {
                            const parentDealResponse = await FetchDealDetails(displayData.parent_deal_id);
                            if (parentDealResponse?.data) {
                                updatedContactList.push(parentDealResponse.data);
                            }
                        } catch (err) {
                            message.error(err);
                        }
                    }
                }
                setDealMapList(updatedContactList)
            }
            catch (error) {
                message.error(error)
            }
        }

    }
    const onchangeDelete = (value) => {
        if (value) {
            form.setFieldsValue({
                contactPerson: [],
                parentDeal: null
            })
        }
    }
    const handleDealTypeChange = (value, option) => {
        setDealTypeData(value)
        setDealTypeField(option.key)
        if (option.key === "Empanelment") {
            form.setFieldsValue({
                typevalue: "Not Applicable",
                dealValue: 0,
                grossdealValue: 0,
                dealprofit: 0,
            });
            setTypeAction("Not Applicable")
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (typeAction === "Not Applicable") {
                form.setFieldsValue({
                    typevalue: null,
                })
                setTypeAction()
            }
        }
        if (option.key !== "Expansion") {
            form.setFieldsValue({
                parentDeal: null
            })
        }
    }
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        setApproveOpen(false)
        setApproveCondition(false)
        setAssignOwner()
        form.setFieldsValue({
            dealOwner: null,
            parentDeal: null,
            dealprofit: null,
            dealname: null,
            dealDescription: null,
            accountName: null,
            contactPerson: [],
            priority: null,
            dealmargin: null,
            expectedClosureDate: null,
            winProbability: null,
            forecastedValue: null,
            revenueStartDate: null,
            revenueEndDate: null,
            commitstatus: null,
            pipelineStage: 1,
            deallostReasons: null,
            dealWonreasons: null,
            dealValue: null,
            grossdealValue: null,
            dealType: null,
            typevalue: null,
            dealonHoldReason: null,
            actualdealmargin: null,
            actualclosureDate: null,
            dealLostDate: null,
            dealonholdDate: null,
            dealrestartDate: null,
            competition: [],
            discountvalue: null,
        })
        setTempWinProp()
        setFileList([])
        setDealValue(0)
        setTotalDeal(0)
        setConatctIds([])
        setExpectedClosureDate()
        setRevenueStartDate()
        setRevenueEndDate()
        setActualclosureDate()
        setDealLostDate()
        setDealonholdDate()
        setDealrestartDate()
        setWinProbability()
        setDealDiscount()
        setRoleData([])
        setServiceData([])
        setFormDatas([])
        handleDealTypeChange(undefined, { key: undefined })
        setTypeAction()
        setImage()
        setDeleteOpen(false)
        setStates({
            ...states,
            selectedRowKeys: []
        });
        setDrawerPage()
        setOldPipeline()
        setOldFixed()
        setPipelineV()
        if (FromPage !== "EntityUpdate" && FromPage !== "AccountPage" && FromPage !== "ContactPage" && ShortCut !== "Shortcut") {
            GetAll();
        }
        if (FromPage !== "EntityUpdate") {
            setCratePage();
        }
        if (drawerPage === "CloneDeal" || ShortCut === "Shortcut") {
            PageCancel()
        }
        setEdit(false);
        setEditWon(false);
        setEditableType(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    const CloseDrawerNew = () => {
        setCancelConfirmOpen(false)
        setDrawerPage()
        setEditWon(false);
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    const mapApiResponseToFormValues = (value) => {
        return value.products.map((product) => ({
            addProductId: product.add_product_id,
            productCategory: product.product_category,
            dealProductId: product.deal_product_id,
            productLicenseSellingPriceUnitMonth: product.product_license_selling_price_unitMonth,
            numberOfUnits: product.number_of_units,
            licenseDuration: product.license_duration,
            total: product.total
        }));
    };
    const mapApiResponseToServicesValues = (value) => {
        return value.service.map((service) => ({
            serviceId: service.service_id,
            serviceName: service.service_name,
            serviceLineId: service.service_line_id,
            serviceLineCost: service.service_line_cost,
        }));
    };
    const mapApiResponseToRoleValues = (value) => {
        return value.staffRoles.map((role) => ({
            staffRoleId: role.staff_role_id,
            addStaffRoleId: role.add_staff_role_id,
            roleName: role.roleName,
            country: role.country,
            rolePerDayRate: role.role_per_day_rate,
            startDate: role.start_date,
            endDate: role.end_date,
            totalValue: role.total_value,
        }));
    };
    function totalCalculation() {
        let sum = 0;
        let totalsum = 0;
        let Fvalue = 0;
        let profit = 0;
        let ChcekdealValueEdit;
        if (typeAction === "Product and Services" || typeAction === "Request for Proposal" || typeAction === "Others") {
            if (isFormDataValid || isservicesDataValid) {
                if (formDatas.length === 0 && servicesData.length === 0) {
                    sum = Number(dealValues) || 0;
                    setDealValueEdit()
                    ChcekdealValueEdit = undefined
                }
                else {
                    if (formDatas.length > 0) {
                        for (let i = 0; i < formDatas.length; i += 1) {
                            if (formDatas[i].total !== undefined)
                                sum += 1 * formDatas[i].total;
                        }
                    }
                    else if (!isservicesDataValid) {
                        sum = Number(dealValues) || 0;
                    }
                    if (servicesData.length > 0) {
                        for (let i = 0; i < servicesData.length; i += 1) {
                            if (servicesData[i].serviceLineCost !== undefined)
                                sum += 1 * servicesData[i].serviceLineCost;
                        }
                    }
                    else if (!isFormDataValid) {
                        sum = Number(dealValues) || 0;
                    }
                    if ((formDatas.length > 0 && isFormDataValid) || (servicesData.length > 0 && isservicesDataValid)) {
                        setDealValueEdit("Disabled")
                        ChcekdealValueEdit = "Disabled"
                    }
                    else {
                        setDealValueEdit()
                        ChcekdealValueEdit = undefined
                    }
                }
            }
            else if (typeAction === "Request for Proposal" || typeAction === "Others") {
                sum = Number(dealValues) || 0;
            }
        }
        if (typeAction === "Staff Augmentation") {
            // if (isroleDataValid) {
            for (let i = 0; i < roleData.length; i += 1) {
                if (roleData[i].totalValue !== undefined)
                    sum += 1 * roleData[i].totalValue;
            }
            // } else {
            //     sum = 0
            // }
        }
        if (!Number.isNaN(Number(dealDiscount)) && dealDiscount !== "" && dealDiscount !== 0) {
            totalsum = sum * (1 - Number(dealDiscount) / 100);
        } else {
            totalsum = sum;
        }
        if (!Number.isNaN(Number(winProbability)) && winProbability !== "" && totalDeal) {
            const dValue = 1 * totalDeal;
            Fvalue = dValue * (Number(winProbability) / 100);
        }
        if (pipeLineField !== "Won") {
            if (!Number.isNaN(Number(changeDealMargin)) && changeDealMargin !== "" && totalDeal) {
                const dValue = 1 * totalDeal;
                profit = dValue * (Number(changeDealMargin) / 100);
            }
        } else if (pipeLineField === "Won") {
            if (!Number.isNaN(Number(changeDealMargin2)) && changeDealMargin2 !== "" && totalDeal) {
                const dValue = 1 * totalDeal;
                profit = dValue * (Number(changeDealMargin2) / 100);
            }
        }
        form.setFieldsValue({
            dealValue: totalsum?.toFixed(CurencyDecimalPlace),
            forecastedValue: Fvalue?.toFixed(CurencyDecimalPlace),
            dealprofit: profit?.toFixed(CurencyDecimalPlace)
        })
        if (((typeAction !== "Request for Proposal" && typeAction !== "Others") || ChcekdealValueEdit === "Disabled")) {
            form.setFieldsValue({
                grossdealValue: sum?.toFixed(CurencyDecimalPlace),
            })
        }
        setTotalDeal(totalsum);
    }
    async function setInitialData(value) {
        const formValues = mapApiResponseToFormValues(value);
        const servicesValues = mapApiResponseToServicesValues(value);
        const roleValues = mapApiResponseToRoleValues(value)
        setDealInitial({
            dealOwner: normalizeValue(value.deal_owner),
            parentDealId: normalizeValue(value.parent_deal_id),
            dealProfit: normalizeValue(value.deal_profit),
            dealName: normalizeValue(value.deal_name),
            dealType: normalizeValue(value.deal_type),
            dealProfile: normalizeValue(value.deal_profile),
            subtype: normalizeValue(value.subtype),
            accountName: normalizeValue(value.account_id),
            pipelineStage: normalizeValue(value.pipeline_stage),
            oldPipelineStage: normalizeValue(value.old_pipeline_stage),
            contactPerson: normalizeValue(value.contact_person),
            dealValue: normalizeValue(value.deal_value),
            priority: normalizeValue(value.priority),
            dealFiles: (value.deal_files || []),
            expectedDealLength: normalizeValue(value.expected_deal_length),
            expectedClosureDate: normalizeValue(value.expected_closure_date),
            winProbability: normalizeValue(value.win_probability),
            competition: normalizeValue(value.competition),
            forecastedValue: normalizeValue(value.forecasted_value),
            revenueStartDate: normalizeValue(value.revenue_start_date),
            revenueEndDate: normalizeValue(value.revenue_end_date),
            grossDealValue: normalizeValue(value.gross_deal_value),
            discountPercentage: normalizeValue(value.discount_percentage),
            commitStatus: normalizeValue(value.commit_status),
            dealWonReason: normalizeValue(value.deal_won_reason),
            actualCloserDate: normalizeValue(value.actual_closer_date),
            actualDealMargin: normalizeValue(value.actual_deal_margin),
            dealLostReason: normalizeValue(value.deal_lost_reason),
            dealLostDate: normalizeValue(value.deal_lost_date),
            dealHoldReason: normalizeValue(value.deal_hold_reason),
            dealHoldDate: normalizeValue(value.deal_hold_date),
            dealRestartDate: normalizeValue(value.deal_restart_date),
            staffRole: roleValues,
            products: formValues,
            services: servicesValues,
            dealDescription: normalizeValue(value.deal_description),
        })
    }
    const setData = async (value) => {
        if (value !== undefined) {
            if (drawerPage !== "CloneLead") {
                if (value.approved_for !== "None") {
                    setApproveOpen(true)
                    setApproveCondition(true)
                }
                else {
                    setApproveOpen(false)
                    setApproveCondition(false)
                }
            }
            const latestCurrencySettings = currencySettingsRef.current;
            const ConvertRates = latestCurrencySettings?.exchangeRate;
            const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
            const formValues = mapApiResponseToFormValues(value);
            const servicesValues = mapApiResponseToServicesValues(value);
            const roleValues = mapApiResponseToRoleValues(value)
            setAssignOwner(value.deal_owner)
            const DealValue = value.deal_value ? await ExchangeCurrency(Number(value.deal_value), ConvertRates) : value.deal_value;
            const GrossDealValue = value.gross_deal_value ? await ExchangeCurrency(Number(value.gross_deal_value), ConvertRates) : value.gross_deal_value;
            const ProfitDealValue = value.deal_profit && value.deal_profit !== "" ? await ExchangeCurrency(Number(value.deal_profit), ConvertRates) : value.deal_profit;
            const ForecastedValue = value.forecasted_value ? await ExchangeCurrency(Number(value.forecasted_value), ConvertRates) : value.forecasted_value;
            const convertedServicesData = await Promise.all(
                servicesValues.map(async (service) => {
                    const convertedCost = await (service.serviceLineCost !== undefined && service.serviceLineCost !== null && service.serviceLineCost !== "" ?
                        ExchangeCurrency(Number(service.serviceLineCost), ConvertRates)
                        : service.serviceLineCost
                    );
                    return {
                        ...service,
                        serviceLineCost: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            const convertedServices = await Promise.all(
                value.service.map(async (service) => {
                    const convertedCost = await (service.service_line_cost !== undefined && service.service_line_cost !== null && service.service_line_cost !== "" ?
                        ExchangeCurrency(Number(service.service_line_cost), ConvertRates)
                        : service.service_line_cost
                    );
                    return {
                        ...service,
                        service_line_cost: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            const convertedRoleData = await Promise.all(
                roleValues.map(async (role) => {
                    const convertedRate = await (role.rolePerDayRate !== undefined && role.rolePerDayRate !== null && role.rolePerDayRate !== ""
                        ? ExchangeCurrency(Number(role.rolePerDayRate), ConvertRates)
                        : role.rolePerDayRate);
                    const convertedTotalValue = await (role.totalValue !== undefined && role.totalValue !== null && role.totalValue !== ""
                        ? ExchangeCurrency(Number(role.totalValue), ConvertRates)
                        : role.totalValue);
                    return {
                        ...role,
                        rolePerDayRate: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                        totalValue: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            const convertedRole = await Promise.all(
                value.staffRoles.map(async (role) => {
                    const convertedRate = await (role.role_per_day_rate !== undefined && role.role_per_day_rate !== null && role.role_per_day_rate !== ""
                        ? ExchangeCurrency(Number(role.role_per_day_rate), ConvertRates) : role.role_per_day_rate);
                    const convertedTotalValue = await (role.total_value !== undefined && role.total_value !== null && role.total_value !== ""
                        ? ExchangeCurrency(Number(role.total_value), ConvertRates) : role.total_value);
                    return {
                        ...role,
                        role_per_day_rate: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                        total_value: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            const convertedFormDatas = await Promise.all(
                formValues.map(async (product) => {
                    const convertedPrice = await (product.productLicenseSellingPriceUnitMonth !== undefined && product.productLicenseSellingPriceUnitMonth !== '' && product.productLicenseSellingPriceUnitMonth !== null
                        ? ExchangeCurrency(Number(product.productLicenseSellingPriceUnitMonth), ConvertRates)
                        : product.productLicenseSellingPriceUnitMonth);
                    const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                        ? ExchangeCurrency(Number(product.total), ConvertRates)
                        : product.total);
                    return {
                        ...product,
                        productLicenseSellingPriceUnitMonth: Number(convertedPrice?.toFixed(CurencyDecimalPlace)),
                        // subtotal: Number(convertedSubtotal?.toFixed(CurencyDecimalPlace)),
                        total: Number(convertedTotal?.toFixed(CurencyDecimalPlace)),
                        // adjustments: product.adjustments !== undefined && product.adjustments !== '' && product.adjustments !== null && product.adjustmentType !== "%" ? Number(convertedAdjustments?.toFixed(CurencyDecimalPlace)) : convertedAdjustments,
                    };
                })
            );
            const convertedForm = await Promise.all(
                value.products.map(async (product) => {
                    const convertedPrice = await (product.product_license_selling_price_unitMonth !== undefined && product.product_license_selling_price_unitMonth !== '' && product.product_license_selling_price_unitMonth !== null
                        ? ExchangeCurrency(Number(product.product_license_selling_price_unitMonth), ConvertRates) : product.product_license_selling_price_unitMonth);
                    const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                        ? ExchangeCurrency(Number(product.total), ConvertRates) : product.total);
                    return {
                        ...product,
                        product_license_selling_price_unitMonth: Number(convertedPrice?.toFixed(CurencyDecimalPlace)),
                        total: Number(convertedTotal?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            form.setFieldsValue({
                dealOwner: value.deal_owner,
                parentDeal: value.parent_deal_id,
                dealprofit: Number(ProfitDealValue?.toFixed(CurencyDecimalPlace)),
                dealname: value.deal_name,
                accountName: value.account_id,
                contactPerson: value.contact_person ? value.contact_person.split(",").map(user => user * 1) : [],
                priority: value.priority,
                dealmargin: value.expected_deal_length,
                expectedClosureDate: value.expected_closure_date !== "" && value.expected_closure_date !== null ?
                    moment(formatDateString(value.expected_closure_date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
                    : null,
                winProbability: value.win_probability,
                forecastedValue: Number(ForecastedValue?.toFixed(CurencyDecimalPlace)),
                revenueStartDate: value.revenue_start_date !== "" && value.revenue_start_date !== null ?
                    moment(formatDateString(value.revenue_start_date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
                    : null,
                revenueEndDate: value.revenue_end_date !== "" && value.revenue_end_date !== null ?
                    moment(formatDateString(value.revenue_end_date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
                    : null,
                commitstatus: value.commit_status,
                pipelineStage: (drawerPage === "CloneDeal" && (value.pipelineStage === "Won" || value.pipelineStage === "Lost")) ?
                    1 : value.pipeline_stage,
                deallostReasons: value.deal_lost_reason,
                dealWonreasons: value.deal_won_reason,
                dealValue: Number(DealValue?.toFixed(CurencyDecimalPlace)),
                dealType: value.deal_type,
                typevalue: value.subtype,
                dealonHoldReason: value.deal_hold_reason,
                actualdealmargin: value.actual_deal_margin !== undefined && value.actual_deal_margin !== null && value.actual_deal_margin !== "" ? value.actual_deal_margin : value.expected_deal_length,
                actualclosureDate: value.actual_closer_date === "" || value.actual_closer_date === null ? moment(formattedCurrentDate) :
                    moment(formatDateString(value.actual_closer_date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                dealLostDate: value.deal_lost_date === "" || value.deal_lost_date === null ? moment(formattedCurrentDate) :
                    moment(formatDateString(value.deal_lost_date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                dealonholdDate: value.deal_hold_date === "" || value.deal_hold_date === null ? moment(formattedCurrentDate) :
                    moment(formatDateString(value.deal_hold_date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                dealrestartDate: value.deal_restart_date === "" || value.deal_restart_date === null ? moment(formattedCurrentDate) :
                    moment(formatDateString(value.deal_restart_date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                competition: value.competition ? value.competition.split(",").map(user => user * 1) : [],
                discountvalue: value.discount_percentage,
                dealDescription: value.deal_description,
            })
            setChangeDealMargin(value.expected_deal_length)
            setChangeDealMargin2(value.actual_deal_margin !== undefined && value.actual_deal_margin !== null && value.actual_deal_margin !== "" ? value.actual_deal_margin : value.expected_deal_length)
            setTempWinProp(value.win_probability)
            setFileList(value.deal_files || [])
            setDealValue(Number(GrossDealValue?.toFixed(CurencyDecimalPlace)))
            setTotalDeal(Number(DealValue?.toFixed(CurencyDecimalPlace)))
            setConatctIds(value.contact_person ? value.contact_person.split(",").map(user => user * 1) : [])
            setExpectedClosureDate(value.expected_closure_date)
            setRevenueStartDate(value.revenue_start_date)
            setRevenueEndDate(value.revenue_end_date)
            setActualclosureDate(value.actual_closer_date === "" || value.actual_closer_date === null ? formattedCurrentDate : value.actual_closer_date)
            setDealLostDate(value.deal_lost_date === "" || value.deal_lost_date === null ? formattedCurrentDate : value.deal_lost_date)
            setDealonholdDate(value.deal_hold_date === "" || value.deal_hold_date === null ? formattedCurrentDate : value.deal_hold_date)
            setDealrestartDate(value.deal_restart_date === "" || value.deal_restart_date === null ? formattedCurrentDate : value.deal_restart_date)
            setWinProbability(value.win_probability)
            setDealDiscount(value.discount_percentage)
            setRoleData(convertedRoleData)
            setServiceData(convertedServicesData)
            setFormDatas(convertedFormDatas)
            setDealId(value.deals_id)
            handleDealTypeChange(value.deal_type, { key: value.deal_type_name })
            setTypeAction(value.subtype)
            setImage(value.deal_profile)
            setDeleteOpen(value.deal_profile && value.deal_profile !== "")
            setStates({
                ...states,
                selectedRowKeys: [value.deals_id]
            });
            if ((drawerPage === "CloneDeal" && (value.pipelineStage === "Won" || value.pipelineStage === "Lost"))) {
                handlePipeLineChange(1, { key: "Prospecting" }, value.win_probability, "Update")
                setPipelineV()
                setOldPipeline(null)
                setOldFixed()
                setEditableType(true)
            } else {
                handlePipeLineChange(value.pipeline_stage, { key: value.pipelineStage }, value.win_probability, "Update")
                if (Role !== "Administrator") {
                    if (value.pipelineStage === "Won" || value.pipelineStage === "Lost") {
                        setEditWon(true)
                        setEditableType(false)
                    } else {
                        setEditableType(true)
                    }
                }
                else {
                    setEditableType(true)
                }
                setPipelineV(value.pipelineStage)
                if ((value.pipelineStage !== "on-Hold" && value.pipelineStage !== "On-Hold") && value.pipelineStage !== "Lost") {
                    setOldPipeline(value.pipeline_stage)
                    setOldFixed(value.pipeline_stage)
                }
                else {
                    setOldPipeline(value.old_pipeline_stage)
                    setOldFixed(value.old_pipeline_stage)
                }
            }
            const updatedPerson = {
                ...value,
                gross_deal_value: Number(GrossDealValue?.toFixed(CurencyDecimalPlace)),
                deal_profit: Number(ProfitDealValue?.toFixed(CurencyDecimalPlace)),
                deal_value: Number(DealValue?.toFixed(CurencyDecimalPlace)),
                forecasted_value: Number(ForecastedValue?.toFixed(CurencyDecimalPlace)),
                products: convertedForm,
                service: convertedServices,
                staffRoles: convertedRole,
                created_at: value.created_at ? convertAndFormatDateTime(value.created_time ? `${value.created_at} ${value.created_time}` : value.created_at, companyProfile, profile) : "",
                modified_at: value.modified_at ? convertAndFormatDateTime(value.modified_time ? `${value.modified_at} ${value.modified_time}` : value.modified_at, companyProfile, profile) : "",
            };
            setDisplayData(updatedPerson)
            if (convertedFormDatas.length === 0 && convertedServicesData.length === 0 && (value.subtype === "Request for Proposal" || value.subtype === "Others")) {
                form.setFieldsValue({
                    grossdealValue: GrossDealValue?.toFixed(CurencyDecimalPlace),
                })
            }
        }
    }
    async function getSharingPermissions(id) {
        if (id) {
            setDataPermissions(id)
        }
        else {
            setDataPermissions("Read,Update,Delete,Sharing")
        }
    }
    async function getData(id) {
        try {
            if (drawerPage === "CloneDeal") {
                const response = await FetchDealDetails(id);
                getSharingPermissions(undefined)
                setData(response.data);
                setDealInitial(InitialData.DealData)
                const transformedItem = {
                    ...response.data,
                    created_at: response.data.created_at ? convertAndFormatDateTime(response.data.created_time ? `${response.data.created_at} ${response.data.created_time}` : response.data.created_at, companyProfile, profile) : "",
                    modified_at: response.data.modified_at ? convertAndFormatDateTime(response.data.modified_time ? `${response.data.modified_at} ${response.data.modified_time}` : response.data.modified_at, companyProfile, profile) : "",
                };
                setDealDetailsData(transformedItem)
            } else {
                const response = await FetchDealDetails(id);
                if (!response.allow) throw new Error();
                getSharingPermissions(response?.data.sharingPermission?.sharePermission)
                setData(response.data);
                setInitialData(response.data)
                const transformedItem = {
                    ...response.data,
                    created_at: response.data.created_at ? convertAndFormatDateTime(response.data.created_time ? `${response.data.created_at} ${response.data.created_time}` : response.data.created_at, companyProfile, profile) : "",
                    modified_at: response.data.modified_at ? convertAndFormatDateTime(response.data.modified_time ? `${response.data.modified_at} ${response.data.modified_time}` : response.data.modified_at, companyProfile, profile) : "",
                };
                setDealDetailsData(transformedItem)
            }
        } catch (error) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    async function getData1(id, hideMessagefn, AutomationMessages, ApprovalMessages, responseData, pipelineID) {
        try {
            const response = await FetchDealDetails(id);
            hideMessagefn();
            if (responseData.data[0].message === AutomationMessages) {
                if (pipelineID === "Won") {
                    dispatch(setExPoCall(true));
                    successMessage("Automation rule triggered", responseData.data[0].message)
                    setTimeout(() => dispatch(setExPoCall(false)), 3000);
                } else {
                    successMessage("Automation rule triggered", responseData.data[0].message)
                }
            }
            else if (responseData.data[0].message !== ApprovalMessages && responseData.data[0].message !== AutomationMessages) {
                if (pipelineID === "Won") {
                    dispatch(setExPoCall(true));
                    successMessage("Proposal Won",
                        <>
                            <img
                                src={require('../../../static/img/defaultImages/Won.gif')}
                                alt="celebration"
                                style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                            />
                            <span>Proposal Closed! Congratulations on winning the proposal! Time to celebrate your success!</span>
                        </>)
                    setTimeout(() => dispatch(setExPoCall(false)), 3000);
                } else {
                    message.success(
                        <span>
                            Proposal <strong>{responseData?.data?.[0]?.entityName}</strong> has been updated successful
                        </span>
                    );
                }
            }
            else {
                message.success(
                    <span>
                        Proposal <strong>{responseData?.data?.[0]?.entityName}</strong> has been updated successfully
                    </span>
                );
            }
            if (!response.allow) throw new Error();
            getSharingPermissions(response?.data.sharingPermission?.sharePermission)
            setData(response.data);
            setInitialData(response.data)
            const transformedItem = {
                ...response.data,
                created_at: response.data.created_at ? convertAndFormatDateTime(response.data.created_time ? `${response.data.created_at} ${response.data.created_time}` : response.data.created_at, companyProfile, profile) : "",
                modified_at: response.data.modified_at ? convertAndFormatDateTime(response.data.modified_time ? `${response.data.modified_at} ${response.data.modified_time}` : response.data.modified_at, companyProfile, profile) : "",
            };
            setDealDetailsData(transformedItem)
            setTrigger("activity")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
        } catch (error) {
            hideMessagefn();
            loadingRef.current = false;
            setDoubleClick(false)
            if (responseData.data[0].message === AutomationMessages) {
                if (pipelineID === "Won") {
                    dispatch(setExPoCall(true));
                    successMessage("Automation rule triggered", responseData.data[0].message)
                    setTimeout(() => dispatch(setExPoCall(false)), 3000);
                } else {
                    successMessage("Automation rule triggered", responseData.data[0].message)
                }
            }
            else if (responseData.data[0].message !== ApprovalMessages && responseData.data[0].message !== AutomationMessages) {
                if (pipelineID === "Won") {
                    dispatch(setExPoCall(true));
                    successMessage("Proposal Won",
                        <>
                            <img
                                src={require('../../../static/img/defaultImages/Won.gif')}
                                alt="celebration"
                                style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                            />
                            <span>Proposal Closed! Congratulations on winning the proposal! Time to celebrate your success!</span>
                        </>)
                    setTimeout(() => dispatch(setExPoCall(false)), 3000);
                } else {
                    message.success(
                        <span>
                            Proposal <strong>{responseData?.data?.[0]?.entityName}</strong> has been updated successfully
                        </span>
                    );
                }
            }
            else {
                message.success(
                    <span>
                        Proposal <strong>{responseData?.data?.[0]?.entityName}</strong> has been updated successfully
                    </span>
                );
            }
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const { NavigationDecrypted } = useNavigationDecrypted();
    async function getEntityAvalibitlity() {
        let dataFound = true;
        try {
            const response = await NavigationDecrypted(UrlId[1])
            if (response) {
                setDealId(response)
                dataFound = true;
                getData(response)
            }
            else {
                dataFound = false;
            }

        } catch (error) {
            dataFound = false;
        }
        if (!dataFound) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    async function ProductApi() {
        try {
            const data = await getProjectList()
            const options = data.filter((item) => item.productActive === "Yes").map((option, i) => (
                <Option value={option.dealProductId} key={i} label={option.productName
                    // (<div style={{ display: 'flex', alignItems: 'center' }} title={`${option.productName} (${option.prodcutCategory})`}>
                    //     <div className='Div_flex2'>
                    //         <div className='share_image' title={`${option.productName} (${option.prodcutCategory})`} style={{ cursor: "default" }}>
                    //             {option.productImg !== null && option.productImg !== undefined && option.productImg !== "" ?
                    //                 < img src={option.productImg} alt="profile" />
                    //                 :
                    //                 <span className="image_icon">
                    //                     {option.productName?.slice(0, 1).toUpperCase()}
                    //                 </span>
                    //             }
                    //             <span className='div-ellipsis'>{option.productName}</span>
                    //         </div>
                    //     </div>
                    // </div>)
                }>
                    <div className='UserList-dropdown' title={`${option.productName} (${option.prodcutCategory})`}>
                        <div>
                            {option.productImg !== null && option.productImg !== undefined && option.productImg !== "" ?
                                < img src={option.productImg} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.productName?.slice(0, 1).toUpperCase()}
                                </span>
                            }
                        </div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.productName}</p>
                            <p style={{ margin: 0 }}>({option.prodcutCategory})</p>
                        </div>
                    </div>
                </Option>));
            setProductdata(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function ServiceLineApi() {
        try {
            const data = await FetchAllServiceLines()
            const options = data.map((option, i) => (
                <Option value={option.service_line_id} key={i} label={option.service_line_name
                    // (<div style={{ display: 'flex', alignItems: 'center' }} >
                    //     <div className='Div_flex2'>
                    //         <div className='share_image' title={option.service_line_name} style={{ cursor: "default" }}>
                    //             <span className="image_icon">
                    //                 {option.service_line_name?.slice(0, 1).toUpperCase()}
                    //             </span>
                    //             <span className='div-ellipsis'>{option.service_line_name}</span>
                    //         </div>
                    //     </div>
                    // </div>)
                }>
                    <div className='UserList-dropdown' title={option.service_line_name}>
                        <div>
                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                {option.service_line_name?.slice(0, 1).toUpperCase()}
                            </span>
                        </div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.service_line_name}</p>
                        </div>
                    </div>
                </Option>));
            setServiceLineData(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function StaffRoleApi() {
        try {
            const data = await findAllStaffRoleByReportingUser()
            setStaffRoleData(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getPipelineStage = async () => {
        try {
            const data = await FetchAllPipeline()
            setPipelineStage(data)
            if (FromPage === "AccountPage" || FromPage === "ContactPage" || FromPage === "ListingDealCreate" || drawerPage === "CloneDeal") {
                handlePipeLineChange(data[0].pipelineStageId, { key: data[0].pipelineStageName })
                form.setFieldsValue({
                    pipelineStage: data[0].pipelineStageId
                })
            }
        }
        catch (error) {
            setPipelineStage([])
            message.error(error)
        }
    };
    async function getSelleingPrice(id) {
        try {
            const response = await getProductDetails(id)
            const price = response.sellingPricePerUnitPerMonth;
            const category = response.prodcutCategory;
            return { success: true, price, category };
        } catch (error) {
            return {
                success: false,
                message: error
            };
        }
    }
    async function getStaffRolePrice(id) {
        try {
            const datas = await getByAddStaffRoleId(id);
            const price = datas.rolePerDayRate;
            return { success: true, price };
        } catch (error) {
            return {
                success: false,
                message: error
            };
        }
    }
    const getWorkingDays = async (id, startDate, endDate) => {
        try {
            const response = await getBussinesDaysForStaffRole(id, startDate, endDate)
            return { success: true, data: response }
        } catch (error) {
            return {
                success: false,
                message: error
            };
        }
    }
    // add Product
    const handleFieldChange = async (index, fieldName, value) => {
        const updatedFormData = [...formDatas];
        updatedFormData[index] = {
            ...updatedFormData[index],
            [fieldName]: value,
        };

        const productId = updatedFormData[index].dealProductId;
        if (productId) {
            const response = await getSelleingPrice(productId)
            if (!response.success) {
                message.error(response.message);
                updatedFormData[index].productLicenseSellingPriceUnitMonth = 0;
                updatedFormData[index].productCategory = null;
                updatedFormData[index].licenseDuration = 1;
            }
            else {
                const Value = response.price
                    ? await ExchangeCurrency(Number(response.price), ConvertRate)
                    : response.price;
                updatedFormData[index].productLicenseSellingPriceUnitMonth = Number(Value?.toFixed(CurencyDecimalPlace));
                updatedFormData[index].productCategory = response.category;
                if (response.category !== "Software") {
                    updatedFormData[index].licenseDuration = 1;
                } else {
                    updatedFormData[index].licenseDuration = updatedFormData[index].licenseDuration && updatedFormData[index].licenseDuration !== "" ?
                        updatedFormData[index].licenseDuration : 1
                }
            }
        }
        const productLicenseSellingPriceUnitMonth = parseFloat(updatedFormData[index].productLicenseSellingPriceUnitMonth || 0);
        const numberOfUnits = parseFloat(updatedFormData[index].numberOfUnits || 0);
        const licenseDuration = parseFloat(updatedFormData[index].licenseDuration || 0);
        if (productLicenseSellingPriceUnitMonth > 0 && numberOfUnits > 0 && licenseDuration > 0) {
            updatedFormData[index].total = (productLicenseSellingPriceUnitMonth * numberOfUnits * licenseDuration)?.toFixed(CurencyDecimalPlace);
        } else {
            updatedFormData[index].total = "";

        }
        setFormDatas(updatedFormData)
    };
    const addNewRow = () => {
        setFormDatas([...formDatas,
        {
            dealProductId: null,
            productCategory: null,
            productLicenseSellingPriceUnitMonth: null,
            numberOfUnits: null,
            licenseDuration: null,
            total: null,
        }]);
    };
    const removeRow = async (index) => {
        const updatedFormData = [...formDatas];
        updatedFormData.splice(index, 1);
        setFormDatas(updatedFormData);
    }
    // add services
    const addNewSerivce = () => {
        setServiceData([...servicesData,
        {
            serviceName: null,
            serviceLineId: null,
            serviceLineCost: null,
        },
        ]);
    };
    const removeservice = async (index) => {
        const updatedFormData = [...servicesData];
        updatedFormData.splice(index, 1);
        setServiceData(updatedFormData);
    };
    const handleServicesChange = async (index, fieldName, value) => {
        const updatedFormData = [...servicesData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            [fieldName]: value,
        };
        setServiceData(updatedFormData);
    };
    // add roles
    const addNewRoles = () => {
        setRoleData([...roleData, {
            addStaffRoleId: null,
            country: null,
            rolePerDayRate: null,
            startDate: null,
            endDate: null,
            totalValue: null,
        }]);
    };
    const removeRoles = async (index) => {
        const updatedFormData = [...roleData];
        updatedFormData.splice(index, 1);
        setRoleData(updatedFormData);
    };
    const handleRolesChange = async (index, fieldName, value, countrys) => {
        const updatedFormData = [...roleData];
        if ((fieldName === "startDate" || fieldName === "endDate") && value) {
            const date = RequiredDateFormating(value)
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: date,
                country: countrys,
            };
        }
        else {
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: value,
                country: countrys,
            };
        }
        const staffRoleId = updatedFormData[index].addStaffRoleId;
        if (staffRoleId) {
            const response = await getStaffRolePrice(staffRoleId)
            if (!response.success) {
                message.error(response.message);
                updatedFormData[index].rolePerDayRate = 0;
            }
            else {
                const Value = response.price ?
                    await ExchangeCurrency(Number(response.price), ConvertRate)
                    : response.price;
                updatedFormData[index].rolePerDayRate = Number(Value?.toFixed(CurencyDecimalPlace));
            }
        }
        const rolePerDayRate = parseFloat(updatedFormData[index].rolePerDayRate || 0);
        let totalBusinessDays = 0;

        if (staffRoleId && updatedFormData[index].startDate && updatedFormData[index].endDate) {
            const responseData = await getWorkingDays(staffRoleId, updatedFormData[index].startDate, updatedFormData[index].endDate);
            if (!responseData.success) {
                message.error(responseData.message);
                totalBusinessDays = 0;
            }
            else {
                totalBusinessDays = responseData.data
            }
        } if (rolePerDayRate > 0 && totalBusinessDays > 0) {
            const total = rolePerDayRate * totalBusinessDays
            updatedFormData[index].totalValue = total?.toFixed(CurencyDecimalPlace)
        }
        else {
            updatedFormData[index].totalValue = ""
        }
        setRoleData(updatedFormData);
    };
    const handleTypeAction = (value) => {
        setTypeAction(value)
        if (value === "Staff Augmentation" && roleData.length === 0) {
            addNewRoles()
            form.setFieldsValue({
                revenueStartDate: null,
                revenueEndDate: null,
            })
            setRevenueStartDate(null)
            setRevenueEndDate(null)
        }
        if (value === "Request for Proposal" || value === "Product and Services") {
            if (formDatas.length === 0) {
                addNewRow()
            }
            if (servicesData.length === 0) {
                addNewSerivce()
            }
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const expectedClosureDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setExpectedClosureDate(formattedDate);
        form.setFieldsValue({ expectedClosureDate: date });
        form.validateFields(['revenueStartDate', 'revenueEndDate']);
    };
    const revenueStartDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setRevenueStartDate(formattedDate);
        form.setFieldsValue({ revenueStartDate: date });
        form.validateFields(['expectedClosureDate', 'revenueEndDate']);
    };
    const revenueEndDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setRevenueEndDate(formattedDate);
        form.setFieldsValue({ revenueEndDate: date });
        form.validateFields(['revenueStartDate']);
    };
    const actualclosuredateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setActualclosureDate(formattedDate);
    };
    const dealLostDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setDealLostDate(formattedDate);
    };
    const dealonholdDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setDealonholdDate(formattedDate);
    };
    const dealrestartDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setDealrestartDate(formattedDate);
    };
    const closeMailComposr = () => {
        setMailOpen(false);
    };
    const HandleShareClick = () => {
        setSharePopup(true)
    }
    const ProductColumns = [
        {
            title: 'Product Name',
            dataIndex: 'PrdutName',
            key: 'PrdutName',
            width: '18%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ? <Select style={{ width: "100%" }}
                        showSearch
                        optionLabelProp="label"
                        optionFilterProp="children"
                        filterOption={(input, option) => {
                            const usernameElement = option.children.props.children[1].props.children[0];
                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                const username = String(usernameElement.props.children);
                                return username.toLowerCase().includes(input.toLowerCase());
                            }
                            return false;
                        }
                        }
                        placeholder="Select Product"
                        name="dealProductId"
                        value={record.dealProductId}
                        onChange={(value) =>
                            handleFieldChange(index, 'dealProductId', value)
                        }
                    >
                        {productdata}
                    </Select>
                        : <span >
                            {displayData?.products?.length > 0 ? displayData?.products[index]?.product_name : ""}
                        </span>}
                </Form.Item>
            ),
        },
        {
            title: `Unit Price (${currencySettings?.currency})`,
            dataIndex: 'PriceperU/M$',
            key: 'PriceperU/M$',
            width: '13%',
            render: (text, record, index) => (
                <Form.Item>
                    {edit ? <Input pattern="^\d+(\.\d+)?$" disabled prefix={currencySettings?.symbol}
                        name="productLicenseSellingPriceUnitMonth"
                        value={record.productLicenseSellingPriceUnitMonth}
                        onChange={(e) =>
                            handleFieldChange(index, 'productLicenseSellingPriceUnitMonth', e.target.value)
                        }
                        placeholder="Unit Price" />
                        :
                        <>{currencySettings?.symbol} <span>
                            {displayData?.products?.length > 0 ? displayData?.products[index]?.product_license_selling_price_unitMonth?.toLocaleString() : ""}
                        </span>
                        </>
                    }
                </Form.Item>
            ),
        },
        {
            title: 'No. of Units',
            dataIndex: 'Numofunits',
            key: 'Numofunits',
            width: '5%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ? <Input min={0}
                        name="numberOfUnits"
                        value={record.numberOfUnits}
                        onChange={(e) => {
                            const { value } = e.target;
                            const isValid = /^\d+(\.\d+)?$/.test(value);
                            if (value === "" || isValid) {
                                handleFieldChange(index, "numberOfUnits", value);
                            }
                        }}
                        placeholder="Number of Units" />
                        : <span >
                            {displayData?.products?.length > 0 ? displayData?.products[index]?.number_of_units : ""}
                        </span>}
                </Form.Item>
            ),
        },
        {
            title: (
                <div>
                    Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="License Duration in months" />
                </div>
            ),
            dataIndex: 'LicenseDutn',
            key: 'LicenseDutn',
            width: '5%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ? <Input min={0}
                        disabled={record.productCategory !== "Software"}
                        name="licenseDuration"
                        value={record.productCategory && record.productCategory !== "Software" ? "One off" : record.licenseDuration}
                        onChange={(e) => {
                            const { value } = e.target;
                            const isValid = /^\d+(\.\d+)?$/.test(value);
                            if (value === "" || isValid) {
                                handleFieldChange(index, "licenseDuration", value);
                            }
                        }}
                        placeholder="License Duration" />
                        : <span >
                            {displayData?.products?.length > 0 ? displayData?.products[index]?.license_duration : ""}
                        </span>}
                </Form.Item>
            ),
        },
        {
            title: `Total (${currencySettings?.currency})`,
            dataIndex: 'Total',
            key: 'Total',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item>
                    {edit ? <Input type="text" disabled prefix={currencySettings?.symbol}
                        name="total"
                        value={record.total}
                        onChange={(e) =>
                            handleFieldChange(index, 'total', e.target.value)
                        }
                        placeholder="Total" />
                        : <>{currencySettings?.symbol} <span >
                            {displayData?.products?.length > 0 ? displayData?.products[index]?.total?.toLocaleString() : ""}
                        </span></>}
                </Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            width: '2%',
            render: (text, record, index) => {
                if (edit && formDatas.length > 0) {
                    return (
                        <FeatherIcon icon="trash-2" size={20} style={{ margin: "0px" }} className="fetcherDelete-Icon"
                            onClick={() => removeRow(index)}
                        />
                    );
                }
            },
        },
        {
            title: '',
            dataIndex: 'addAction',
            key: 'addAction',
            width: '2%',
            render: (text, record, index) => {
                if (edit && index === formDatas.length - 1) {
                    return (
                        <PlusCircleOutlined
                            title="Add New Product"
                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "0px", }}
                            onClick={addNewRow}
                        />
                    );
                }
            },
        }
    ];
    const ServicesColumns = [
        {
            title: 'Service Name',
            dataIndex: 'ServiceName',
            key: 'ServiceName',
            width: '30%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ? <Input placeholder='Enter Service Name'
                        name="serviceName"
                        value={record.serviceName}
                        onChange={(e) =>
                            handleServicesChange(index, 'serviceName', e.target.value)
                        } />
                        : <span >
                            {displayData?.service?.length > 0 ? displayData?.service[index]?.service_name : ""}
                        </span>}
                </Form.Item>
            ),
        },
        {
            title: 'Service Line Name',
            dataIndex: 'ServiceLineName',
            key: 'ServiceLineName',
            width: '35%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ?
                        <Select style={{ width: "100%" }}
                            showSearch
                            optionLabelProp="label"
                            optionFilterProp="children"
                            filterOption={(input, option) => {
                                const usernameElement = option.children.props.children[1].props.children[0];
                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                    const username = String(usernameElement.props.children);
                                    return username.toLowerCase().includes(input.toLowerCase());
                                }
                                return false;
                            }
                            }
                            placeholder="Enter Service Line Name"
                            name="serviceLineId"
                            value={record.serviceLineId}
                            onChange={(value) =>
                                handleServicesChange(index, 'serviceLineId', value)
                            }
                        >
                            {serviceLineData}
                        </Select>
                        : <span>
                            {displayData?.service?.length > 0 ? displayData?.service[index]?.service_line_name : ""}
                        </span>
                    }
                </Form.Item>
            ),
        },
        {
            title: `Service Line Cost (${currencySettings?.currency})`,
            dataIndex: 'ServiceLineCost',
            key: 'ServiceLineCost',
            width: '31%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ? <Input placeholder='Enter Service Line Cost' min={0} prefix={currencySettings?.symbol}
                        name="serviceLineCost"
                        value={record.serviceLineCost}
                        onChange={(e) => {
                            const { value } = e.target;
                            if (value === "") {
                                handleServicesChange(index, "serviceLineCost", value);
                                return;
                            }
                            const basicNumberCheck = /^\d+(\.\d*)?$/;
                            if (!basicNumberCheck.test(value)) return;
                            const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                            if (!decimalRegex.test(value)) return;
                            handleServicesChange(index, "serviceLineCost", value);
                        }} />
                        : <>{currencySettings?.symbol} <span >
                            {displayData?.service?.length > 0 ? displayData?.service[index]?.service_line_cost?.toLocaleString() : ""}
                        </span></>}
                </Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            width: '2%',
            render: (text, record, index) => {
                if (edit && servicesData.length > 0) {
                    return (
                        <FeatherIcon icon="trash-2" size={20} style={{ margin: "0px", }} className="fetcherDelete-Icon"
                            onClick={() => removeservice(index)}
                        />
                    );
                }
            },
        },
        {
            title: '',
            dataIndex: 'addAction',
            key: 'addAction',
            width: '2%',
            render: (text, record, index) => {
                if (edit && index === servicesData.length - 1) {
                    return (
                        <PlusCircleOutlined
                            title="Add New Services"
                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "0px", }}
                            onClick={addNewSerivce}
                        />
                    );
                }
            },
        }
    ];
    const StaffColumns = [
        {
            title: 'Role Name',
            dataIndex: 'RoleName',
            key: 'RoleName',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ?
                        <Select style={{ width: "100%" }}
                            showSearch optionLabelProp="label"
                            optionFilterProp="children"
                            filterOption={(input, option) => {
                                const usernameElement = option.children.props.children[1].props.children[0];
                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                    const username = String(usernameElement.props.children);
                                    return username.toLowerCase().includes(input.toLowerCase());
                                }
                                return false;
                            }
                            }
                            placeholder="Select Staff Role"
                            name="addStaffRoleId"
                            value={record.addStaffRoleId}
                            onChange={(value, option) => {
                                handleRolesChange(index, 'addStaffRoleId', value, option.name);
                            }}
                        >
                            {staffRoleData.map((option, i) => (
                                <Option value={option.addStaffRoleId} key={i} name={option.country}
                                    label={option.roleName
                                        // (<div style={{ display: 'flex', alignItems: 'center' }} >
                                        //     <div className='Div_flex2'>
                                        //         <div className='share_image' title={`${option.roleName} (${option.country})`} style={{ cursor: "default" }}>
                                        //             <span className="image_icon">
                                        //                 {option.roleName?.slice(0, 1).toUpperCase()}
                                        //             </span>
                                        //             <span className='div-ellipsis'>{option.roleName}</span>
                                        //         </div>
                                        //     </div>
                                        // </div>)
                                    }>
                                    <div className='UserList-dropdown' title={`${option.roleName} (${option.country})`}>
                                        <div>
                                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                {option.roleName?.slice(0, 1).toUpperCase()}
                                            </span>
                                        </div>
                                        <div>
                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.roleName}</p>
                                            <p style={{ margin: 0 }}>({option.country})</p>
                                        </div>
                                    </div>
                                </Option>))}
                        </Select>
                        :
                        <span >
                            {displayData?.staffRoles?.length > 0 ? `${displayData?.staffRoles[index]?.roleName} ${displayData?.staffRoles[index]?.country}` : ""}
                        </span>}
                </Form.Item>
            ),
        },
        {
            title: `Per Day Rate (${currencySettings?.currency})`,
            dataIndex: 'RolePerDayRate',
            key: 'RolePerDayRate',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item>
                    {edit ? <Input placeholder='Role Per Day Rate' pattern="^\d+(\.\d+)?$" min={0}
                        name="rolePerDayRate" prefix={currencySettings?.symbol}
                        disabled
                        value={record.rolePerDayRate}
                        onChange={(e) =>
                            handleRolesChange(index, 'rolePerDayRate', e.target.value, record.country)
                        } /> : <>{currencySettings?.symbol} <span >
                            {displayData?.staffRoles?.length > 0 ? displayData?.staffRoles[index]?.role_per_day_rate?.toLocaleString() : ""}
                        </span></>}
                </Form.Item>
            ),
        },
        {
            title: 'Start Date',
            dataIndex: 'StartDate',
            key: 'StartDate',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ?
                        <DatePicker
                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                            value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                            name="startDate"
                            disabledDate={(current) => {
                                const closure = expectedClosureDate ? moment(expectedClosureDate, "YYYY-MM-DD").startOf("day") : null;
                                const end = record.endDate ? moment(record.endDate, "YYYY-MM-DD").startOf("day") : null;

                                return current && (
                                    current < moment().startOf("day") ||
                                    (closure && current.isBefore(closure, 'day')) ||
                                    (end && current.isAfter(end, 'day'))
                                );
                            }}
                            placeholder="Select Start Date"
                            onChange={(date, dateString) =>
                                handleRolesChange(index, 'startDate', dateString, record.country)
                            }
                        />
                        :
                        <span >
                            {displayData?.staffRoles?.length > 0 ?
                                displayData?.staffRoles[index]?.start_date ? moment(displayData?.staffRoles[index].start_date).format(profile.dateFormate) : (displayData?.staffRoles[index]?.start_date && moment(displayData?.staffRoles[index].start_date).format("YYYY-MM-DD")) : ""}
                        </span>}
                </Form.Item>
            ),
        },
        {
            title: 'End Date',
            dataIndex: 'EndDate',
            key: 'EndDate',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ?
                        <>
                            <DatePicker
                                name="endDate"
                                format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                disabledDate={(current) => {
                                    const start = record.startDate ? moment(record.startDate, "YYYY-MM-DD").startOf("day") : null;
                                    const closure = expectedClosureDate ? moment(expectedClosureDate, "YYYY-MM-DD").startOf("day") : null;

                                    return current && (
                                        current < moment().startOf("day") ||
                                        (start && current.isBefore(start, 'day')) ||
                                        (closure && current.isBefore(closure, 'day'))
                                    );
                                }}
                                placeholder="Select End Date"
                                onChange={(date, dateString) =>
                                    handleRolesChange(index, 'endDate', dateString, record.country)
                                }
                            />
                        </>
                        :
                        <span >
                            {displayData?.staffRoles?.length > 0 ?
                                displayData?.staffRoles[index]?.end_date ? moment(displayData?.staffRoles[index].end_date).format(profile.dateFormate) : (displayData?.staffRoles[index]?.end_date && moment(displayData?.staffRoles[index].end_date).format("YYYY-MM-DD")) : ""}
                        </span>}
                </Form.Item>
            ),
        },
        {
            title: `Total Value (${currencySettings?.currency})`,
            dataIndex: 'TotalValue',
            key: 'TotalValue',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    {edit ? <Input placeholder='Enter Total Value' disabled prefix={currencySettings?.symbol}
                        name="totalValue"
                        value={record.totalValue}
                        onChange={(e) =>
                            handleRolesChange(index, 'totalValue', e.target.value, record.country)
                        } /> : <>{currencySettings?.symbol} <span >{displayData?.staffRoles?.length > 0 ? displayData?.staffRoles[index]?.total_value?.toLocaleString() : ""}
                        </span></>}
                </Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            // width: '5%',
            render: (text, record, index) => {
                if (edit && roleData.length > 0) {
                    return (
                        <FeatherIcon icon="trash-2" size={20} style={{ margin: "0px" }} className="fetcherDelete-Icon"
                            onClick={() => removeRoles(index)}
                        />
                    );
                }
            },
        },
        {
            title: '',
            dataIndex: 'addAction',
            key: 'addAction',
            // width: '5%',
            render: (text, record, index) => {
                if (edit && index === roleData.length - 1) {
                    return (
                        <PlusCircleOutlined
                            title="Add New Staff Augmentation"
                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "0px", }}
                            onClick={addNewRoles}
                        />
                    );
                }
            },
        }
    ];
    const handleDeleteImage = () => {
        setImage(null);
        setDeleteOpen(false);
    };
    const FileUpload = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: 'image/*',
        action: `${getBaseURL()}/usermgmt/uploadFile`, // api for image upload
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                // setState({ ...state, file: info.file, list: info.fileList });
            }
            if (status === 'done') {
                setImage(info.file.response.mediaUrl);// to set that image url
                setDeleteOpen(true)
                message.success(`${info.file.name} File upload successful`);
            } else if (status === 'error') {
                message.error(`${info.file.name} File upload failed`);
            }
        },
        listType: 'picture',
        showUploadList: false,
    };
    const CreateTask = (id) => {
        setCreatePageTask("ListingLead")
        setNaCTrigger("trigger")
        setTaskProp({
            type: "Deal",
            ids: [id]
        })
    }
    const CreateMail = async (IdDatas) => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            try {
                if (IdDatas.length > 0) {
                    const attendeeData = await Promise.all(
                        IdDatas.map(async (id) => {
                            const res = await fetchAttendeeData(id);
                            return {
                                id: res.contacts_id,
                                type: "Contacts"
                            }
                        })
                    );
                    setNaCTrigger("trigger")
                    setEmailAttendees(attendeeData);
                    setMailOpen(true);
                }
                else {
                    setNaCTrigger("trigger")
                    setEmailAttendees([]);
                    setMailOpen(true);
                }
            } catch (error) {
                message.error(error)
            }
        }
    }
    const CreateMeeting = async (IdDatas) => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            try {
                if (IdDatas.length > 0) {
                    const attendeeData = await Promise.all(
                        IdDatas.map(async (ids) => {
                            const response = await fetchAttendeeData(ids);
                            return {
                                id: ids,
                                name: `${response?.first_name} ${response?.last_name}`,
                                type: "Contacts",
                                email: response?.email
                            };
                        })
                    );
                    setNaCTrigger("trigger")
                    setMeetingAttendees(attendeeData);
                    setMeetingOpen(true);
                }
                else {
                    setMeetingAttendees([]);
                    setMeetingOpen(true);
                }
            } catch (error) {
                message.error(error)
            }
        }
    }
    const OndealvalueChange = (value) => {
        setDealValue(value)
    }
    const getUserDetail = async () => {
        if (UrlId === undefined || UrlId === null) {
            if (profile.department === "Sales") {
                form.setFieldsValue({
                    dealOwner: profile.userId,
                    priority: 2,
                });
            }
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            AccountApi(),
            handleAccountChange(displayData?.account_id, displayData?.contact_person),
            UserDetailsApi(),
            getAllAccoutbyType(),
            PriorityApi(),
            DealTypeApi(),
            DealLoseApi(),
            DealOnHoldApi(),
            DealWonApi(),
            ProductApi(),
            ServiceLineApi(),
            StaffRoleApi(),
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (FromPage) {
            scroolup()
            if (defaultCurrency) {
                setCurrencySetting(defaultCurrency);
            }
            getPipelineStage()
        }
    }, [FromPage])
    useEffect(() => {
        currencySettingsRef.current = currencySettings;
    }, [currencySettings]);
    useEffect(() => {
        if (currencySettings) {
            const currentUrlId = JSON.stringify(UrlId); // <-- serialize for comparison
            const currentFromPage = FromPage;
            const isCloneLead = drawerPage === "CloneDeal";
            if (
                !isCloneLead &&
                DealprevValues.current.UrlId === currentUrlId &&
                DealprevValues.current.FromPage === currentFromPage
            ) {
                return;
            }
            DealprevValues.current = {
                UrlId: currentUrlId,
                FromPage: currentFromPage,
            };
            if (FromPage) {
                if (FromPage === "EntityUpdate") {
                    if (drawerPage === "CloneDeal") {
                        getData(dealId)
                        setDataPermissions("Read,Update,Delete,Sharing")
                        setEditField(true)
                        setEdit(true)
                        setEditableType(true)
                    }
                    else {
                        getEntityAvalibitlity()
                    }
                }
                else {
                    form.setFieldsValue({
                        dealOwner: undefined,
                        parentDeal: undefined,
                        dealprofit: undefined,
                        dealname: undefined,
                        // accountName: undefined,
                        // contactPerson: [],
                        priority: undefined,
                        dealmargin: 0,
                        expectedClosureDate: null,
                        winProbability: 0,
                        forecastedValue: undefined,
                        revenueStartDate: undefined,
                        revenueEndDate: undefined,
                        commitstatus: undefined,
                        pipelineStage: 1,
                        deallostReasons: undefined,
                        dealWonreasons: undefined,
                        dealValue: undefined,
                        grossdealValue: undefined,
                        dealType: undefined,
                        typevalue: undefined,
                        dealonHoldReason: undefined,
                        actualdealmargin: undefined,
                        competition: [],
                        discountvalue: 0,
                        dealDescription: undefined
                    })
                    setDisplayData("Create")
                    setDealInitial(InitialData.DealData)
                    setDataPermissions("Read,Update,Delete,Sharing")
                    getUserDetail()
                    setEdit(true)
                    setDealId()
                    setEditableType(true)
                    form.setFieldsValue({
                        actualclosureDate: moment(formattedCurrentDate),
                        dealLostDate: moment(formattedCurrentDate),
                        dealonholdDate: moment(formattedCurrentDate),
                        dealrestartDate: moment(formattedCurrentDate),
                    })
                    setActualclosureDate(formattedCurrentDate)
                    setDealLostDate(formattedCurrentDate)
                    setDealonholdDate(formattedCurrentDate)
                    setDealrestartDate(formattedCurrentDate)
                    setEditField(true)
                }
            }
        }
    }, [UrlId, currencySettings, FromPage, drawerPage]);
    useEffect(() => {
        if (typeAction === "Staff Augmentation" && FromPage) {
            let minStart = null;
            let maxEnd = null;
            roleData.forEach(role => {
                const { startDate, endDate } = role;
                const parsedStartDate = startDate !== null && startDate !== undefined && startDate !== "" ? startDate : null
                const parsedEndDate = endDate !== null && endDate !== undefined && endDate !== "" ? endDate : null
                if (!minStart || (parsedStartDate && parsedStartDate < minStart)) {
                    minStart = parsedStartDate;
                }
                if (!maxEnd || (parsedEndDate && parsedEndDate > maxEnd)) {
                    maxEnd = parsedEndDate;
                }
            });
            const StartDateFormate = formatDateString(minStart, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            const EndDateFormate = formatDateString(maxEnd, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            form.setFieldsValue({
                revenueStartDate: minStart !== null && minStart !== undefined && minStart !== "" ? moment(StartDateFormate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD") : null,
                revenueEndDate: maxEnd !== null && maxEnd !== undefined && maxEnd !== "" ? moment(EndDateFormate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD") : null,
            })
            setRevenueStartDate(minStart);
            setRevenueEndDate(maxEnd);
        }
    }, [roleData, FromPage]);
    useEffect(() => {
        if (FromPage) {
            totalCalculation()
        }
    }, [formDatas, servicesData, roleData, winProbability, typeAction, dealValues, dealDiscount, totalDeal, FromPage, changeDealMargin, changeDealMargin2, pipeLineField])
    useEffect(() => {
        if (FromPage) {
            if (FromPage === "AccountPage") {
                form.setFieldsValue({
                    accountName: dataForDeal?.AccountId,
                    contactPerson: []
                })
                handleAccountChange(dataForDeal?.AccountId, "")
            }
            else if (FromPage === "ContactPage") {
                form.setFieldsValue({
                    accountName: dataForDeal?.AccountId,
                    contactPerson: dataForDeal?.contactId
                })
                handleAccountChange(dataForDeal?.AccountId, "")
            }
            else {
                form.setFieldsValue({
                    accountName: undefined,
                    contactPerson: [],
                })
            }
        }
    }, [FromPage])
    useEffect(() => {
        if (FromPage && editField && displayData && currencySettings) {
            fetchAll()
        }
    }, [displayData, FromPage, currencySettings, editField])
    const handleEditChange = () => {
        if (approveCondition) {
            setApproveOpen(true)
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (Role !== "Administrator") {
                if (pipeLineField === "Won" || pipeLineField === "Lost") {
                    setEditWon(true)
                    setEditField(true)
                    dispatch(setEditCall(true))
                }
                else {
                    setEdit(true)
                    setEditField(true)
                    dispatch(setEditCall(true))
                }
            }
            else {
                setEditField(true)
                setEdit(true)
                dispatch(setEditCall(true))
                handleAccountChange(displayData?.account_id, "");
                handlePipeLineChange(displayData?.pipeline_stage, { key: displayData?.pipelineStage }, tempWinProp, "Update");
                handleDealTypeChange(displayData?.deal_type, { key: displayData?.deal_type_name });
                setTrigger("");
                setApproveOpen(false)
            }

        }
    }
    const CloneLead = () => {
        setDrawerPage("CloneDeal")
    }
    const moreAction = "Yes"
    const MoreAction = ({ closeDropdown }) => (
        <div style={{
            padding: "0px 10px",
            width: "100%",
            height: "100%",
        }}>
            <Link to={combinedUrl}
                onClick={(edit || !canCreate(permissions, 2014)) ? undefined : () => { CloneLead(); closeDropdown() }}
                className={`text_icon ${(edit || !canCreate(permissions, 2014)) ? "disabled_link" : ''}`}>
                <CloneIcon height={15} width={15} marginRight={5} /> Clone
            </Link>
            <Link to={combinedUrl} onClick={(edit || !canShare(dataPermissions, "Sharing")) ? undefined : () => { HandleShareClick(); closeDropdown() }} className={`text_icon ${(edit || !canShare(dataPermissions, "Sharing")) ? 'disabled_link' : ""}`}>
                <ShareIcon height={16} width={16} marginRight={5} /> Share
            </Link>
            <Link to={combinedUrl} onClick={!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2015) ? () => { AssignToFucntion(); closeDropdown() } : undefined} className={`text_icon ${canUpdateDelete(permissions, dataPermissions, "Update", 2015) ? "" : 'disabled_link'}`}>
                <ChangeOwnerIcon height={15} width={15} marginRight={5} /> Change Owner
            </Link>
            <Link to={combinedUrl} onClick={(edit || !canCreate(permissions, 2014)) ? undefined : () => { handleNoteClick("Create"); closeDropdown() }} className={`text_icon ${(edit || !canCreate(permissions, 2014)) ? "disabled_link" : ''}`}>
                <NotesIcon height={13} width={13} marginRight={5} /> Add a Note
            </Link>
        </div >
    );
    MoreAction.propTypes = {
        closeDropdown: PropTypes.func.isRequired,
    };
    const ButtonActions = [
        {
            Actions: <div className={(!canCreate(permissions, 2014)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Send Email'
                onClick={(!canCreate(permissions, 2014)) ? undefined : () => CreateMail(contactIds)}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2014) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateMail(contactIds)
                    }
                }}
                aria-label='mail'
            > <EmailIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2014)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Schedule a Meeting'
                onClick={(!canCreate(permissions, 2014)) ? undefined : () => CreateMeeting(contactIds)}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2014) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateMeeting(contactIds)
                    }
                }}
                aria-label='Meeting'
            > <CalendarIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2014)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Create Task'
                onClick={(!canCreate(permissions, 2014)) ? undefined : () => CreateTask(dealId)}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2014) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateTask(dealId)
                    }
                }}
                aria-label='task'
            > <TaskIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2014)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Log a Call'
                onClick={(!canCreate(permissions, 2014)) ? undefined : () => handleCallLogClick("Create")}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2014) && (event.key === 'Enter' || event.key === ' ')) {
                        handleCallLogClick("Create")
                    }
                }}
                aria-label='phone'
            > <CallLogIcon height={20} width={20} /></div>
        },
    ]
    const LeadInfos = {
        profile: image,
        Classname: "DealIcon",
        letterIcon: displayData?.deal_name,
        name: displayData?.deal_name,
        subName: displayData?.accountName,
        mainAction: <>
            {(!(pipelineV === "Proposal" && canCreate(permissions, 2014)) || edit) ? undefined :
                <Button className="button_colors" size="small" style={{ width: "60%" }} onClick={() => CreateQuotes(dealId, displayData?.account_id)}>
                    <QuotesIcon height={25} width={25} marginRight={5} />Add Quote
                </Button>}
        </>,
    }
    const validateRows = (rows, requiredFields, entityName = 'Row') => {
        const rowIndex = rows.findIndex(row =>
            requiredFields.some(
                field => row[field] === null || row[field] === undefined || row[field] === ''
            )
        );
        if (rowIndex !== -1) {
            message.error(<span>
                Please complete the missing fields in Row <strong>{rowIndex + 1}</strong> under <strong>{entityName}</strong>
            </span>);
            return false; // stop execution
        }
        return true; // all rows valid
    };
    const hasAnyValue = (item) => {
        return Object.values(item).some(val => val !== null && val !== undefined && val !== '');
    };
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        if (typeAction === "Request for Proposal") {
            if (formDatas.length > 0) {
                const anyValue = formDatas.some(row => hasAnyValue(row));
                if (anyValue) {
                    if (!validateRows(formDatas, ['dealProductId', 'numberOfUnits', 'licenseDuration'], 'Add Products')) return;
                }
            }
            if (servicesData.length > 0) {
                const anyValue = servicesData.some(row => hasAnyValue(row));
                if (anyValue) {
                    if (!validateRows(servicesData, ['serviceName', 'serviceLineId', 'serviceLineCost'], 'Add Services')) return;
                }
            }
        }
        if (typeAction === "Product and Services") {
            const productsHaveData = formDatas.some(hasAnyValue);
            const servicesHaveData = servicesData.some(hasAnyValue);
            if (!productsHaveData && !servicesHaveData) {
                message.error("Please add at least one Product or Service");
                return;
            }
            if (productsHaveData) {
                if (!validateRows(formDatas, ['dealProductId', 'numberOfUnits', 'licenseDuration'], 'Add Products')) return;
            }
            if (servicesHaveData) {
                if (!validateRows(servicesData, ['serviceName', 'serviceLineId', 'serviceLineCost'], 'Add Services')) return;
            }
        }
        if (typeAction === "Staff Augmentation") {
            if (roleData.length > 0) { if (!validateRows(roleData, ['addStaffRoleId', 'country', 'rolePerDayRate', 'startDate', 'endDate', 'totalValue'], 'Add Roles')) return; }
        }
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        const { accountName, contactPerson, competition, dealDescription, deallostReasons, dealOwner, dealprofit, parentDeal, dealType, grossdealValue, dealValue, dealWonreasons, commitstatus, dealmargin, dealname, forecastedValue, pipelineStage, priority, winProbability, typevalue, dealonHoldReason, actualdealmargin, } = values;
        const DealValue = dealValue
            ? await convertCurrency(ConvertRate, Number(dealValue))
            : dealValue;
        const ProfitValue = dealprofit
            ? await convertCurrency(ConvertRate, Number(dealprofit))
            : dealprofit;
        const GrossDealValue = grossdealValue
            ? await convertCurrency(ConvertRate, Number(grossdealValue))
            : grossdealValue;
        const ForecastedValue = forecastedValue
            ? await convertCurrency(ConvertRate, Number(forecastedValue))
            : forecastedValue;
        const convertedServicesData = await Promise.all(
            servicesData.map(async (service) => {
                const convertedCost = await (service.serviceLineCost !== undefined && service.serviceLineCost !== null && service.serviceLineCost !== "" ?
                    convertCurrency(ConvertRate, Number(service.serviceLineCost))
                    : service.serviceLineCost
                );
                return {
                    ...service,
                    serviceLineCost: convertedCost?.toString(),
                };
            })
        );
        const convertedRoleData = await Promise.all(
            roleData.map(async (role) => {
                const convertedRate = await (role.rolePerDayRate !== undefined && role.rolePerDayRate !== null && role.rolePerDayRate !== ""
                    ? convertCurrency(ConvertRate, Number(role.rolePerDayRate))
                    : role.rolePerDayRate);
                const convertedTotalValue = await (role.totalValue !== undefined && role.totalValue !== null && role.totalValue !== "" ?
                    convertCurrency(ConvertRate, Number(role.totalValue))
                    : role.totalValue);
                return {
                    ...role,
                    rolePerDayRate: convertedRate?.toString(),
                    totalValue: convertedTotalValue?.toString(),
                };
            })
        );
        const convertedFormDatas = await Promise.all(
            formDatas.map(async (product) => {
                const convertedPrice = await (product.productLicenseSellingPriceUnitMonth !== undefined && product.productLicenseSellingPriceUnitMonth !== '' && product.productLicenseSellingPriceUnitMonth !== null
                    ? convertCurrency(ConvertRate, Number(product.productLicenseSellingPriceUnitMonth))
                    : product.productLicenseSellingPriceUnitMonth);
                const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                    ? convertCurrency(ConvertRate, Number(product.total))
                    : product.total);
                return {
                    ...product,
                    productLicenseSellingPriceUnitMonth: convertedPrice?.toString(),
                    total: convertedTotal?.toString(),
                };
            })
        );
        const formData =
        {
            dealOwner: normalizeValue(dealOwner),
            parentDealId: normalizeValue(parentDeal),
            dealProfit: normalizeValue(ProfitValue?.toString()),
            dealName: normalizeValue(dealname),
            dealType: normalizeValue(dealType),
            dealProfile: normalizeValue(image),
            subtype: normalizeValue(typevalue),
            accountName: normalizeValue(accountName),
            pipelineStage: normalizeValue(pipelineStage),
            oldPipelineStage: normalizeValue((pipeLineField === "on-Hold" || pipeLineField === "On-Hold" || pipeLineField === "Lost") ? oldPipeline : null),
            contactPerson: (contactPerson && contactPerson.length > 0) ? contactPerson.join(',') : null,
            dealValue: normalizeValue(DealValue?.toString()),
            priority: normalizeValue(priority),
            dealFiles: FILEList,
            expectedDealLength: normalizeValue(pipeLineField === "Won" ? actualdealmargin : dealmargin),
            expectedClosureDate: normalizeValue(expectedClosureDate),
            winProbability: normalizeValue(winProbability),
            competition: (competition && competition.length > 0) ? competition.join(',') : null,
            forecastedValue: normalizeValue(ForecastedValue?.toString()),
            revenueStartDate: normalizeValue(revenueStartDate),
            revenueEndDate: normalizeValue(revenueEndDate),
            grossDealValue: normalizeValue(GrossDealValue?.toString()),
            discountPercentage: normalizeValue(dealDiscount),
            dealDescription: normalizeValue(dealDescription),
        }
        formData.commitStatus =
            (pipeLineField !== "Prospecting" && pipeLineField !== "Qualification" && pipeLineField !== "Discovery")
                ? normalizeValue(commitstatus) : null;
        if (pipeLineField === "Won") {
            formData.dealWonReason = normalizeValue(dealWonreasons);
            formData.actualCloserDate = normalizeValue(actualclosureDate);
            formData.actualDealMargin = normalizeValue((actualdealmargin && actualdealmargin !== "") ? Number(actualdealmargin) : undefined)
        } else { formData.dealWonReason = null; formData.actualCloserDate = null; formData.actualDealMargin = null; }
        if (pipeLineField === "Lost") {
            formData.dealLostReason = normalizeValue(deallostReasons);
            formData.dealLostDate = normalizeValue(dealLostDate);
        }
        else { formData.dealLostReason = null; formData.dealLostDate = null; }
        if (pipeLineField === "on-Hold" || pipeLineField === "On-Hold") {
            formData.dealHoldReason = normalizeValue(dealonHoldReason);
            formData.dealHoldDate = normalizeValue(dealonholdDate);
            formData.dealRestartDate = normalizeValue(dealrestartDate);
        }
        else { formData.dealHoldReason = null; formData.dealHoldDate = null; formData.dealRestartDate = null; }
        const hasValidData = (obj) =>
            Object.values(obj).some(val => val !== null && val !== undefined && val !== "");

        if (typeAction === "Staff Augmentation") {
            formData.staffRole = convertedRoleData;
            formData.products = [];
            formData.services = [];
        } else if (typeAction === "Product and Services" || typeAction === "Request for Proposal") {
            formData.products = convertedFormDatas.filter(hasValidData);
            formData.services = convertedServicesData.filter(hasValidData);
            formData.staffRole = [];
        } else {
            formData.staffRole = [];
            formData.products = [];
            formData.services = [];
        }
        const updatedFields = getChangedFields(formData, dealInitial);
        if (Object.keys(updatedFields).length === 0) {
            getData(dealId)
            scroolup()
            message.success("Proposal updated")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
            return;
        }
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage === "EntityUpdate" && drawerPage !== "CloneDeal") {
                const response = await DealUpdate(updatedFields, dealId)
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        loadingRef.current = false;
                        setDoubleClick(false)
                        hideMessage();
                    }
                    else {
                        const ownerChanged = displayData?.deal_owner !== dealOwner;
                        if (response.data[0].message === ApprovalMessage) {
                            hideMessage();
                            getData(dealId)
                            scroolup()
                            successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                            loadingRef.current = false;
                            setDoubleClick(false)
                            CloseDrawerNew()
                        }
                        else if (ownerChanged) {
                            hideMessage();
                            if (response.data[0].message === AutomationMessage) {
                                if (pipeLineField === "Won") {
                                    dispatch(setExPoCall(true));
                                    successMessage("Automation rule triggered", response.data[0].message)
                                    setTimeout(() => dispatch(setExPoCall(false)), 3000);
                                } else {
                                    successMessage("Automation rule triggered", response.data[0].message)
                                }
                            }
                            else if (response.data[0].message !== ApprovalMessage && response.data[0].message !== AutomationMessage) {
                                if (pipeLineField === "Won") {
                                    dispatch(setExPoCall(true));
                                    successMessage("Proposal Won",
                                        <>
                                            <img
                                                src={require('../../../static/img/defaultImages/Won.gif')}
                                                alt="celebration"
                                                style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                            />
                                            <span>Proposal Closed! Congratulations on winning the proposal! Time to celebrate your success!</span>
                                        </>)
                                    setTimeout(() => dispatch(setExPoCall(false)), 3000);
                                } else {
                                    message.success(
                                        <span>
                                            Proposal <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                        </span>
                                    );
                                }
                            }
                            else {
                                message.success(
                                    <span>
                                        Proposal <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                    </span>
                                );
                            }
                            dispatch(setEditCall(false));
                            history.push('/Home/proposals');
                        }
                        else {
                            getData1(dealId, hideMessage, AutomationMessage, ApprovalMessage, response, pipeLineField)
                            scroolup()
                        }
                    }
                }
            }
            else {
                const response = await createDeals(updatedFields)
                if (response.status === 201) {
                    hideMessage();
                    if (response?.data === AutomationMessage) {
                        if (ShortCut === "Shortcut" || FromPage === "ContactPage" || FromPage === "AccountPage") {
                            if (pipeLineField === "Won") {
                                dispatch(setExPoCall(true))
                                successMessage("Automation rule triggered", response?.data)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            }
                            else if (ShortCut !== "Shortcut" && FromPage !== "AccountPage" && FromPage === "ContactPage") {
                                dispatch(setExPoCall(true))
                                successMessage("Automation rule triggered", response?.data)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            }
                            else {
                                successMessage("Automation rule triggered", response?.data)
                            }
                        }
                        else if (drawerPage === "CloneDeal") {
                            if (pipeLineField === "Won") {
                                dispatch(setExPoCall(true));
                                successMessage("Automation rule triggered", response?.data)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            } else {
                                successMessage("Automation rule triggered", response?.data)
                            }
                        }
                        else {
                            const isture = pipeLineField === "Won"
                            if (isture) {
                                dispatch(setExPoCall(true));
                                successMessage("Automation rule triggered", response?.data)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            } else {
                                successMessage("Automation rule triggered", response?.data)
                            }
                        }
                    }
                    else if (response?.data === ApprovalMessage) {
                        successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                    }
                    else if (response?.data !== ApprovalMessage && response?.data !== AutomationMessage) {
                        if (ShortCut === "Shortcut" || FromPage === "ContactPage" || FromPage === "AccountPage") {
                            if (pipeLineField === "Won") {
                                dispatch(setExPoCall(true))
                                successMessage("Proposal Won",
                                    <>
                                        <img
                                            src={require('../../../static/img/defaultImages/Won.gif')}
                                            alt="celebration"
                                            style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                        />
                                        <span>Proposal Closed! Congratulations on winning the proposal! Time to celebrate your success!</span>
                                    </>)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            }
                            else if (ShortCut !== "Shortcut" && FromPage !== "AccountPage" && FromPage === "ContactPage") {
                                dispatch(setExPoCall(true))
                                successMessage("Proposal created",
                                    <>
                                        <img
                                            src={require('../../../static/img/defaultImages/Deal.gif')}
                                            alt="celebration"
                                            style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                        />
                                        <span>New Proposal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                                    </>)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            }
                            else {
                                successMessage("Proposal created", <>
                                    <img
                                        src={require('../../../static/img/defaultImages/Deal.gif')}
                                        alt="celebration"
                                        style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                    />
                                    <span>New Proposal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                                </>)
                            }
                        }
                        else if (drawerPage === "CloneDeal") {
                            if (pipeLineField === "Won") {
                                dispatch(setExPoCall(true));
                                successMessage("Proposal Won",
                                    <>
                                        <img
                                            src={require('../../../static/img/defaultImages/Won.gif')}
                                            alt="celebration"
                                            style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                        />
                                        <span>Proposal Closed! Congratulations on winning the proposal! Time to celebrate your success!</span>
                                    </>)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            } else {
                                successMessage("Deal created", <>
                                    <img
                                        src={require('../../../static/img/defaultImages/Deal.gif')}
                                        alt="celebration"
                                        style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                    />
                                    <span>New Proposal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                                </>)
                            }
                        }
                        else {
                            const isture = pipeLineField === "Won"
                            if (isture) {
                                dispatch(setExPoCall(true));
                                successMessage("Proposal Won", <>
                                    <img
                                        src={require('../../../static/img/defaultImages/Won.gif')}
                                        alt="celebration"
                                        style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                    />
                                    <span>Proposal Closed! Congratulations on winning the proposal! Time to celebrate your success!</span>
                                </>)
                                setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            } else {
                                successMessage("Proposal created", <>
                                    <img
                                        src={require('../../../static/img/defaultImages/Deal.gif')}
                                        alt="celebration"
                                        style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                    />
                                    <span>New Proposal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                                </>)
                            }
                        }
                    }
                    else {
                        successMessage("Proposal created", <>
                            <img
                                src={require('../../../static/img/defaultImages/Deal.gif')}
                                alt="celebration"
                                style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                            />
                            <span>New Proposal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                        </>)
                    }
                    if (FromPage === "AccountPage" || FromPage === "ContactPage") {
                        CallBackTrigger("Callback")
                    }
                    loadingRef.current = false;
                    setDoubleClick(false)
                    CloseDrawer()
                }
            }
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            message.error(error)
        }
    }
    const showConfirmForAccount = (values) => {
        const modal = Modal.confirm({
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span>Associated Account Change</span>
                </div>
            ),
            icon: null,
            content: (
                <p>You are about to change the associated account for this record. This may affect linked data. Continue?</p>
            ),
            centered: true,
            className: "customice-confirm-modal",
            okText: "No",
            cancelText: "Yes",
            okButtonProps: {
                className: "button_colorsModal"
            },
            cancelButtonProps: {
                className: "gray-buttonModal"
            },
            okCancel: true,
            onOk() {
                modal.destroy();
            },
            onCancel() {
                onSubmit(values)
            },
        });
    };
    const onSubmit1 = async (values) => {
        if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
            if (values.accountName !== displayData.account_id) {
                showConfirmForAccount(values)
            }
            else {
                onSubmit(values)
            }
        } else {
            onSubmit(values)
        }
    }
    const memoUrlId = useMemo(() => (UrlId ? [UrlId[0], dealId] : null), [UrlId, dealId]);
    const getDetailsDatas = useCallback(() => getData(dealId), [dealId]);
    const UpdateDetails = (<DealStatusBar UrlId={memoUrlId} getDetailsData={getDetailsDatas} setTrigger={setTrigger}
        leadStatusData={pipeLineStage}
        displayData={dealDetailsData}
        currencySettings={currencySettings}
        setNaCTrigger={setNaCTrigger}
        canUpdateDelete={canUpdateDelete} UpdatePs={{ permission: permissions, dataPermission: dataPermissions, type: "Update", PId: 2015 }} ApprovalMessage={ApprovalMessage} AutomationMessage={AutomationMessage} setErrorData={setErrorData} setIsModalVisible1={setIsModalVisible1} />)
    const LeadDetails = (<DealFields ApprovalMessage={ApprovalMessage} AutomationMessage={AutomationMessage} editWon={editWon} ViewDetailPage={ViewDetailPage} displayData={dealDetailsData} currencySettings={currencySettings} setErrorData={setErrorData} setIsModalVisible1={setIsModalVisible1} dealInitial={dealInitial} setTrigger={setTrigger} canUpdateDelete={canUpdateDelete} permissions={permissions} dataPermissions={dataPermissions} getData={getDetailsDatas} DealData={Data.Deals} />);
    const RelatedDetails = (<RelatedTab EntityType="Deal" UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailapiValues} displayData={displayData} currencySettings={currencySettings} trigger={trigger} />)
    const RightRelatedDetails = (<DealRightData displayData={displayData} profile={profile} ViewDetailPage={ViewDetailPage} UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} currencySettings={currencySettings} trigger={trigger} />)
    const CloseDrawer2 = () => {
        if (FromPage !== "AccountPage" || FromPage !== "ContactPage") {
            scroolup()
            getData(dealId)
        }
        setEditWon(false);
        setEditField(false)
        setEdit(false);
        dispatch(setEditCall(false))
        setDrawerPage()
    }
    const PageCancel1 = () => {
        if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
            CloseDrawer2()
        }
        else if (FromPage === "EntityUpdate" && drawerPage === "CloneLead") {
            setCancelConfirmOpen(true)
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    const getRefreshtheTable = () => {
        CloseDrawer2()
        setTrigger("activity");
    }
    return (
        <>
            {FromPage === "EntityUpdate" ?
                <Main>
                    {displayData ? <>
                        {FromPage === "EntityUpdate" &&
                            <DetailsPage PageCancel={PageCancel} handleEditChange={handleEditChange} canUpdateDelete={canUpdateDelete} entity="Deal" editWon={editWon}
                                UpdatePs={{ permission: permissions, dataPermission: dataPermissions, type: "Update", PId: 2015 }} moreAction={moreAction}
                                DetailsPageMoreAction={<MoreAction />} ButtonActions={ButtonActions} Maincontent={LeadInfos} UpdateDataPage={UpdateDetails}
                                EntityTabDetails={LeadDetails} EntityRelatedTab={RelatedDetails} RightRelatedDetails={RightRelatedDetails}
                            />}
                    </>
                        :
                        <div className="spin">
                            <Spin />
                        </div>}
                </Main> : <></>}
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    FromPage === "EntityUpdate" ?
                        drawerPage === "CloneDeal" ? "Clone Proposal" :
                            <span>
                                Update Proposal
                                {displayData?.deal_name && (
                                    <>
                                        <span style={{
                                            margin: '0 10px',
                                            color: '#d9d9d9',
                                            fontWeight: 'normal'
                                        }}>|</span>
                                        <span style={{ fontWeight: 'normal' }}>
                                            {displayData?.deal_name}
                                        </span>
                                    </>
                                )}
                            </span>
                        : "Create Proposal"
                }
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space>
                }
                footer={
                    (uiReady && edit) ? [
                        <div className="form_action_button">
                            <Button
                                className="gray-button" size="small"
                                onClick={() => PageCancel1()}
                            >
                                <CancelIcon height={25} width={25} />Cancel
                            </Button>
                            {FromPage === "EntityUpdate" && drawerPage !== "CloneDeal" ?
                                (pipelineV === "Won" && typeAction !== "Staff Augmentation") && editWon ? "" :
                                    <Button disabled={!canUpdateDelete(permissions, dataPermissions, "Delete", 2016) || deleteClick || doubleClick} loading={deleteClick}
                                        className="red-button" size="small"
                                        onClick={() => deleteMenu(dealId)}
                                    >
                                        {!deleteClick && <DeleteIcon height={25} width={25} />}Delete
                                    </Button> : <></>}
                            <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} disabled={deleteClick || doubleClick} loading={doubleClick}>
                                {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" && drawerPage !== "CloneDeal" ? "Update" : "Save"}
                            </Button>
                        </div>] : false
                }
            >
                {(uiReady && displayData) ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={(values) => onSubmit1(values)} onFinishFailed={onFinishFailed} colon={false} >
                                <BasicFormWrapper>
                                    <VerticalFormStyleWrap>
                                        <div className="add-product-block">
                                            <div style={{ margin: 40 }}>
                                                <Row gutter={15}>
                                                    <Col xs={24}>
                                                        <div className="add-product-content">
                                                            <Heading as="h5">Proposal Pipeline Stage</Heading>
                                                            <Row gutter={30} style={{ margin: "30px 0px 20px" }}>
                                                                <Col span={22} style={{ marginBottom: 10 }}>
                                                                    <Form.Item name="pipelineStage"
                                                                        id="pipelineStage"
                                                                        rules={edit && editableType ? [{ required: true, message: 'Please select a pipeline stage', }] : [{ required: false }]}>
                                                                        <PipelineStagesArrow
                                                                            stages={pipeLineStage}
                                                                            currentStage={pipelineData}
                                                                            onStageClick={(index, name) => handlePipeLineChange(index, { key: name }, tempWinProp)}
                                                                            completedColor="#007bff"
                                                                            upcomingColor="#e0e0e0"
                                                                            textColor="#fff"
                                                                            arrowHeight={40}
                                                                            notchSize={6}
                                                                            editableType={editableType}
                                                                            edit={edit}
                                                                            displayData={displayData}
                                                                            oldPipeline={oldPipeline}
                                                                            pipeLineStage={pipeLineStage}
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            <Heading as="h5">Basic Information</Heading>
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Proposal Name" name="dealname" id="dealname"
                                                                        rules={edit ? [{ required: true, message: 'Please enter proposal name' }, {
                                                                            validator: (_, value) => {
                                                                                const error = nameOnChangeValidator(value, 50);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        }] : [{ required: false }]}
                                                                    >
                                                                        {edit ? <Input placeholder="Enter Proposal Name" />
                                                                            : <>
                                                                                <span className='text_icon'>
                                                                                    {displayData?.deal_name}
                                                                                </span>
                                                                            </>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }} >
                                                                    <Form.Item label="Proposal Owner" name="dealOwner"
                                                                        id="dealOwner"
                                                                        rules={edit ? [{ required: true, message: 'Please select a proposal owner', }] : [{ required: false }]}>
                                                                        {edit ?
                                                                            <Select style={{ width: '100%' }}
                                                                                placeholder="Select Proposal Owner"
                                                                                showSearch
                                                                                optionLabelProp="label"
                                                                                filterOption={(input, option) => {
                                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                        const username = String(usernameElement.props.children);
                                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                                    }
                                                                                    return false;
                                                                                }
                                                                                }
                                                                            >
                                                                                {users}
                                                                            </Select>
                                                                            : <>
                                                                                <UserOwnerDetails record={{
                                                                                    recordbyFName: displayData?.userFirstName,
                                                                                    recordbyLName: displayData?.userLastName,
                                                                                    recordby: displayData?.deal_owner,
                                                                                    recordbyProfilePic: displayData?.userProfilePic
                                                                                }} />
                                                                            </>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }} >
                                                                    <Form.Item label="Account Name" name="accountName"
                                                                        id="accountName" rules={edit ? [{ required: true, message: 'Please select an account name', }] : [{ required: false }]}>
                                                                        {edit ?
                                                                            <Select style={{ width: '100%' }}
                                                                                placeholder="Select Account Name"
                                                                                showSearch optionLabelProp="label"
                                                                                optionFilterProp="children"
                                                                                filterOption={(input, option) => {
                                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                        const username = String(usernameElement.props.children);
                                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                                    }
                                                                                    return false;
                                                                                }
                                                                                }
                                                                                onChange={(value) => { handleAccountChange(value); onchangeDelete(value) }}
                                                                            >
                                                                                {account.filter((item) => item.account_type_name === "Customer").map((option, i) => (
                                                                                    <Option value={option.account_id} key={i} label={(
                                                                                        <div style={{ display: 'flex', alignItems: 'center' }} >
                                                                                            <div className='Div_flex2'>
                                                                                                <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                                                                                    {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                                        < img src={option.account_profile} alt="profile" />
                                                                                                        :
                                                                                                        <span className="image_icon AccountIcon">
                                                                                                            {option.account_name?.slice(0, 1).toUpperCase()}
                                                                                                        </span>
                                                                                                    }
                                                                                                    <span className='div-ellipsis'>{option.account_name}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>)}>
                                                                                        <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                                                                                            <div>
                                                                                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                                    < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                    :
                                                                                                    <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                        {option.account_name?.slice(0, 1).toUpperCase()}
                                                                                                    </span>
                                                                                                }</div>
                                                                                            <div>
                                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                                                <p style={{ margin: 0 }}>{option.account_number}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Option>))
                                                                                }
                                                                            </Select>
                                                                            :
                                                                            <AccountDetails permission={{
                                                                                isPresent: displayData?.accountPermission,
                                                                                id: displayData?.account_id,
                                                                                profile: displayData?.accountProfile,
                                                                                name: displayData?.accountName
                                                                            }} />
                                                                        }
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Proposal Urgency" name="priority"
                                                                        id="priority">
                                                                        {edit ? <Select style={{ width: '100%' }} onChange={(value) => form.setFieldsValue({ priority: value || null })} allowClear placeholder="Select Proposal Urgency">
                                                                            {dealPriority}
                                                                        </Select>
                                                                            : <>
                                                                                <span className='text_icon'>
                                                                                    {displayData?.priority_name}
                                                                                </span>
                                                                            </>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Proposal Type" name="dealType"
                                                                        id="dealType"
                                                                        rules={edit ? [{ required: true, message: 'Please select a proposal type', }] : [{ required: false }]}
                                                                    >
                                                                        {edit ? <Select style={{ width: '100%' }} placeholder="Select Proposal Type" value={dealTypeData} onChange={handleDealTypeChange}>
                                                                            {dealType.map((option) => (
                                                                                <Option value={option.dealTypeId} key={option.dealTypeName}>
                                                                                    {option.dealTypeName}
                                                                                </Option>))}
                                                                        </Select>
                                                                            : <span >{displayData?.deal_type_name}</span>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Proposal SubType" name="typevalue"
                                                                        id="typevalue"
                                                                        rules={pipeLineField !== "Prospecting" && dealTypeField !== "Empanelment" && edit ? [{ required: true, message: 'Please select a proposal sub type', }] : [{ required: false }]}
                                                                    >
                                                                        {edit ? <Select disabled={dealTypeField !== "New" && dealTypeField !== "Expansion"} allowClear
                                                                            style={{ width: '100%' }} placeholder="Select Proposal SubType" value={typeAction} onChange={handleTypeAction} >
                                                                            <Option value="Request for Proposal">Request for Proposal</Option>
                                                                            <Option value="Staff Augmentation">Staff Augmentation</Option>
                                                                            <Option value="Product and Services">Product and Services</Option>
                                                                            <Option value="Others">Others</Option>
                                                                            {dealTypeField === "Empanelment" && <Option value="Not Applicable">Not Applicable</Option>}
                                                                        </Select>
                                                                            : <span >{displayData?.subtype}</span>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Competition"
                                                                        name="competition"
                                                                        id="competition"
                                                                    >
                                                                        {edit ?
                                                                            <Select style={{ width: '100%' }}
                                                                                placeholder="Select Competition Account"
                                                                                showSearch mode="multiple" optionLabelProp="label"
                                                                                optionFilterProp="children"
                                                                                filterOption={(input, option) => {
                                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                        const username = String(usernameElement.props.children);
                                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                                    }
                                                                                    return false;
                                                                                }
                                                                                }
                                                                            >
                                                                                {accountbyType.filter((item) => item.account_type_name === "Competitor").map((option, i) => (
                                                                                    <Option value={option.account_id} key={i} label={(
                                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.account_name} (${option.account_number})`}>
                                                                                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                                < img src={option.account_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                                                                                :
                                                                                                <span className='details_span_Tag AccountIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                                                                                    {option.account_name?.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                                        </div>)}>
                                                                                        <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                                                                                            <div>
                                                                                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                                    < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                    :
                                                                                                    <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                        {option.account_name?.slice(0, 1).toUpperCase()}
                                                                                                    </span>
                                                                                                }</div>
                                                                                            <div>
                                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                                                <p style={{ margin: 0 }}>{option?.account_number}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Option>))
                                                                                }
                                                                            </Select>
                                                                            : <div className='table_list_clicks' style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                flexWrap: "nowrap",
                                                                                minWidth: "max-content",
                                                                            }}>
                                                                                {displayData?.competitiondata && displayData?.competitiondata.length > 0 && (<>
                                                                                    {displayData?.competitiondata?.slice(0, 5).map((item, index) => {
                                                                                        if (!item.competitionName) {
                                                                                            return null;
                                                                                        }
                                                                                        return (
                                                                                            <TaskRelatedItem
                                                                                                displayData={{
                                                                                                    task_type_name: "Account"
                                                                                                }}
                                                                                                key={index}
                                                                                                item={{
                                                                                                    id: Number(item.competitionId),
                                                                                                    name: item?.competitionName,
                                                                                                    profilePic: item.competitionProfile
                                                                                                }}
                                                                                                permission={{ isPresent: item.competitionPermission }}
                                                                                                ViewDetailPage={ViewDetailPage}
                                                                                            />
                                                                                        )
                                                                                    })}
                                                                                    {displayData?.competitiondata?.length > 5 && (
                                                                                        <Popover
                                                                                            placement="bottomLeft"
                                                                                            trigger="hover"
                                                                                            content={
                                                                                                <div
                                                                                                    style={{
                                                                                                        maxHeight: "200px",
                                                                                                        overflowY: "auto",
                                                                                                        display: "flex",
                                                                                                        flexDirection: "column",
                                                                                                        gap: "8px",
                                                                                                        padding: "4px 0",
                                                                                                    }}
                                                                                                >
                                                                                                    {displayData?.competitiondata?.slice(5).map((item, index) => {
                                                                                                        if (!item.competitionName) {
                                                                                                            return null;
                                                                                                        }
                                                                                                        return (
                                                                                                            <TaskRelatedItem1
                                                                                                                displayData={{
                                                                                                                    task_type_name: "Account"
                                                                                                                }}
                                                                                                                key={index}
                                                                                                                item={{
                                                                                                                    id: Number(item.competitionId),
                                                                                                                    name: item?.competitionName,
                                                                                                                    profilePic: item.competitionProfile
                                                                                                                }}
                                                                                                                permission={{ isPresent: item.competitionPermission }}
                                                                                                                ViewDetailPage={ViewDetailPage}
                                                                                                            />
                                                                                                        )
                                                                                                    })}
                                                                                                </div>
                                                                                            }
                                                                                        >
                                                                                            <span
                                                                                                style={{
                                                                                                    marginLeft: "25px",
                                                                                                    fontSize: "13px",
                                                                                                    fontWeight: 500,
                                                                                                    color: "#1677ff",
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                            >
                                                                                                +{displayData.competitiondata.length - 5} more
                                                                                            </span>
                                                                                        </Popover>
                                                                                    )}
                                                                                </>)}
                                                                            </div>}
                                                                    </Form.Item>
                                                                </Col>
                                                                {dealTypeField === "Expansion" ? <>
                                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                                        <Form.Item label="Parent Proposal Name" name="parentDeal"
                                                                            id="parentDeal"
                                                                            rules={dealTypeField === "Expansion" && edit ? [{ required: true, message: 'Please select a parent proposal', }] : [{ required: false }]}
                                                                        >
                                                                            {edit ? <Select allowClear={dealTypeField !== "Expansion"} optionLabelProp="label"
                                                                                optionFilterProp="children"
                                                                                filterOption={(input, option) => {
                                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                        const username = String(usernameElement.props.children);
                                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                                    }
                                                                                    return false;
                                                                                }
                                                                                }
                                                                                style={{ width: '100%' }} placeholder="Select Parent Proposal"  >
                                                                                {dealMapList.filter((item) => item.deals_id !== dealId).map((option, i) => (
                                                                                    <Option value={option.deals_id} key={i} label={(
                                                                                        <div style={{ display: 'flex', alignItems: 'center' }} >
                                                                                            <div className='Div_flex2'>
                                                                                                <div className='share_image' title={`${option.deal_name} (${option.pipelineStage})`} style={{ cursor: "default" }}>
                                                                                                    {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                                                                                        < img src={option.deal_profile} alt="profile" />
                                                                                                        :
                                                                                                        <span className="image_icon DealIcon">
                                                                                                            {option.deal_name?.slice(0, 1).toUpperCase()}
                                                                                                        </span>
                                                                                                    }
                                                                                                    <span className='div-ellipsis'>{option.deal_name}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>)}>
                                                                                        <div className='UserList-dropdown' title={`${option.deal_name} (${option.pipelineStage})`}>
                                                                                            <div>
                                                                                                {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                                                                                    < img src={option.deal_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                    :
                                                                                                    <span className='details_span_Tag DealIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                        {option.deal_name?.slice(0, 1).toUpperCase()}
                                                                                                    </span>
                                                                                                }</div>
                                                                                            <div>
                                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.deal_name}</p>
                                                                                                <p style={{ margin: 0 }}>{option?.pipelineStage}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Option>))
                                                                                }
                                                                            </Select>
                                                                                :
                                                                                <DealDetails permission={{
                                                                                    isPresent: displayData?.parentDealPermission,
                                                                                    id: displayData?.parent_deal_id,
                                                                                    profile: displayData?.parentDealProfile,
                                                                                    name: displayData?.parentDealName
                                                                                }}
                                                                                    currecny={currencySettings}
                                                                                />}
                                                                        </Form.Item>
                                                                    </Col>
                                                                </> : ""}
                                                                {pipeLineField !== "Prospecting" && pipeLineField !== "Qualification" && pipeLineField !== "Discovery" &&
                                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                                        <Form.Item label="Commit Status" name="commitstatus" id="commitstatus"
                                                                            rules={((pipeLineField === "Won" || pipeLineField === "Negotiation") && edit) ? [{ required: true, message: 'Please select commit status', }] : [{ required: false }]}
                                                                        >
                                                                            {edit ? <Select style={{ width: '100%' }} placeholder="Select Commit Status">
                                                                                <Option value="Hard Commit">Hard Commit</Option>
                                                                                <Option value="Soft Commit">Soft Commit</Option>
                                                                            </Select>
                                                                                : <span >{displayData?.commit_status}</span>}
                                                                        </Form.Item>
                                                                    </Col>
                                                                }
                                                                <Col span={24} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Description" name="dealDescription" id="dealDescription" rules={
                                                                        [
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const error = validateDescriptionField(value, 2500);
                                                                                    if (error) {
                                                                                        return Promise.reject(new Error(error));
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                },
                                                                            },
                                                                        ]
                                                                    }>
                                                                        {edit ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Description' /> : <>
                                                                            <span className='text_icon'>
                                                                                {displayData?.deal_description}
                                                                            </span>
                                                                        </>}
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            <Heading as="h5">Resident Information</Heading>
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Resident Person" name="contactPerson"
                                                                        id="contactPerson"
                                                                        rules={pipeLineField !== "Prospecting" && dealTypeField !== "Empanelment" && edit ? [{ required: true, message: 'Please select a resident person', }] : [{ required: false }]}
                                                                    >
                                                                        {edit ?
                                                                            <Select style={{ width: '100%' }}
                                                                                placeholder="Select Resident Person"
                                                                                showSearch optionLabelProp="label"
                                                                                mode="multiple"
                                                                                optionFilterProp="children"
                                                                                filterOption={(input, option) => {
                                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                        const username = String(usernameElement.props.children);
                                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                                    }
                                                                                    return false;
                                                                                }
                                                                                }>
                                                                                {contacts.map((option, i) => (
                                                                                    <Option value={option.contacts_id} key={i} label={(
                                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.first_name} ${option.last_name} (${option.email})`}>
                                                                                            {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                                                                                < img src={option.contact_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                                                                                :
                                                                                                <span className='details_span_Tag ContactIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                                                                                    {option.first_name?.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                                                                        </div>)} >
                                                                                        <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.email})`}>
                                                                                            <div>
                                                                                                {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                                                                                    < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                    :
                                                                                                    <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                        {option.first_name?.slice(0, 1).toUpperCase()}
                                                                                                    </span>
                                                                                                }</div>
                                                                                            <div>
                                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                                                                                <p style={{ margin: 0 }}>{option?.email}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Option>))
                                                                                }
                                                                            </Select>
                                                                            :
                                                                            <div className='table_list_clicks' style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                flexWrap: "nowrap",
                                                                                minWidth: "max-content",
                                                                            }}>
                                                                                {displayData?.contactNames && displayData?.contactNames.length > 0 && (<>
                                                                                    {displayData?.contactNames?.slice(0, 5).map((item, index) => {
                                                                                        if (!item.contactPersonName) {
                                                                                            return null;
                                                                                        }
                                                                                        return (
                                                                                            <TaskRelatedItem
                                                                                                displayData={{
                                                                                                    task_type_name: "Contact"
                                                                                                }}
                                                                                                key={index}
                                                                                                item={{
                                                                                                    id: Number(item.contactPersonId),
                                                                                                    name: item?.contactPersonName,
                                                                                                    profilePic: item.contactPersonProfileic
                                                                                                }}
                                                                                                permission={{ isPresent: item?.contactPersonPermission }}
                                                                                                ViewDetailPage={ViewDetailPage}
                                                                                            />
                                                                                        )
                                                                                    })}
                                                                                    {displayData?.contactNames?.length > 5 && (
                                                                                        <Popover
                                                                                            placement="bottomLeft"
                                                                                            trigger="hover"
                                                                                            content={
                                                                                                <div
                                                                                                    style={{
                                                                                                        maxHeight: "200px",
                                                                                                        overflowY: "auto",
                                                                                                        display: "flex",
                                                                                                        flexDirection: "column",
                                                                                                        gap: "8px",
                                                                                                        padding: "4px 0",
                                                                                                    }}
                                                                                                >
                                                                                                    {displayData.contactNames.slice(5).map((item, index) => {
                                                                                                        if (!item.contactPersonName) {
                                                                                                            return null;
                                                                                                        }
                                                                                                        return (
                                                                                                            <TaskRelatedItem1
                                                                                                                displayData={{
                                                                                                                    task_type_name: "Contact"
                                                                                                                }}
                                                                                                                key={index}
                                                                                                                item={{
                                                                                                                    id: Number(item.contactPersonId),
                                                                                                                    name: item?.contactPersonName,
                                                                                                                    profilePic: item.contactPersonProfileic
                                                                                                                }}
                                                                                                                permission={{ isPresent: item?.contactPersonPermission }}
                                                                                                                ViewDetailPage={ViewDetailPage}
                                                                                                            />
                                                                                                        )
                                                                                                    })}
                                                                                                </div>
                                                                                            }
                                                                                        >
                                                                                            <span
                                                                                                style={{
                                                                                                    marginLeft: "25px",
                                                                                                    fontSize: "13px",
                                                                                                    fontWeight: 500,
                                                                                                    color: "#1677ff",
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                            >
                                                                                                +{displayData.contactNames.length - 5} more
                                                                                            </span>
                                                                                        </Popover>
                                                                                    )}
                                                                                </>)}
                                                                            </div>}
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            <Heading as="h5">Proposal Information</Heading>
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Expected Proposal Margin" name="dealmargin"
                                                                        id="dealmargin" rules={[
                                                                            {
                                                                                validator: async (_, value) => {
                                                                                    if (value === undefined || value === null || value === '') {
                                                                                        return Promise.resolve();
                                                                                    }
                                                                                    // Strict numeric check (digits with optional 1 dot)
                                                                                    const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                    if (!basicNumberCheck.test(value)) {
                                                                                        return Promise.reject(new Error('Please enter a valid number'));
                                                                                    }

                                                                                    // Check decimal places (must be ≤ 2)
                                                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                    if (!decimalRegex.test(value)) {
                                                                                        return Promise.reject(
                                                                                            new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                                        );
                                                                                    }

                                                                                    const num = Number(value); // Now it's guaranteed to be a proper number

                                                                                    if (num < 0 || num > 100) {
                                                                                        return Promise.reject(new Error('Percentage must be between 0 and 100'));
                                                                                    }

                                                                                    return Promise.resolve();
                                                                                }

                                                                            }
                                                                        ]}>
                                                                        {edit ? <Input prefix="%" placeholder='Enter Expected Proposal Margin' disabled={pipeLineField === "Won"} onChange={(e) => setChangeDealMargin(e.target.value)} onBlur={(e) => {
                                                                            if (e.target.value === '') {
                                                                                form.setFieldsValue({ dealmargin: 0 });
                                                                                setChangeDealMargin(0);
                                                                            }
                                                                        }} />
                                                                            : <>
                                                                                <span className='text_icon'>
                                                                                    % {displayData?.expected_deal_length}
                                                                                </span>
                                                                            </>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Win Probability" name="winProbability"
                                                                        id="winProbability" rules={pipeLineField !== "Prospecting" && dealTypeField !== "Empanelment" && edit ? [{ required: true, message: 'Please enter win probability' }
                                                                            , {
                                                                            validator: async (_, value) => {
                                                                                if (value === undefined || value === null || value === '') {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                // Strict numeric check (digits with optional 1 dot)
                                                                                const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                if (!basicNumberCheck.test(value)) {
                                                                                    return Promise.reject(new Error('Please enter a valid number'));
                                                                                }

                                                                                // Check decimal places (must be ≤ 2)
                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                if (!decimalRegex.test(value)) {
                                                                                    return Promise.reject(
                                                                                        new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                                    );
                                                                                }

                                                                                const num = Number(value); // Now it's guaranteed to be a proper number

                                                                                if (num < 0 || num > 100) {
                                                                                    return Promise.reject(new Error('Percentage must be between 0 and 100'));
                                                                                }

                                                                                return Promise.resolve();
                                                                            }
                                                                        }
                                                                        ] : [{ required: false }, {
                                                                            validator: async (_, value) => {
                                                                                if (value === undefined || value === null || value === '') {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                // Strict numeric check (digits with optional 1 dot)
                                                                                const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                if (!basicNumberCheck.test(value)) {
                                                                                    return Promise.reject(new Error('Please enter a valid number'));
                                                                                }

                                                                                // Check decimal places (must be ≤ 2)
                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                if (!decimalRegex.test(value)) {
                                                                                    return Promise.reject(
                                                                                        new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                                    );
                                                                                }

                                                                                const num = Number(value); // Now it's guaranteed to be a proper number

                                                                                if (num < 0 || num > 100) {
                                                                                    return Promise.reject(new Error('Percentage must be between 0 and 100'));
                                                                                }

                                                                                return Promise.resolve();
                                                                            }

                                                                        }]}>
                                                                        {edit ? <Input prefix="%" min={0} max={100} value={winProbability} disabled={pipeLineField === "Won" || pipeLineField === "Lost"} placeholder='Enter Win probability'
                                                                            onChange={(e) => setWinProbability(e.target.value)} onBlur={(e) => {
                                                                                if (e.target.value === '') {
                                                                                    form.setFieldsValue({ winProbability: 0 });
                                                                                    setWinProbability(0);
                                                                                }
                                                                            }}
                                                                        /> : <span >% {displayData?.win_probability}</span>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label={`Forecasted Value (${currencySettings?.currency})`} name="forecastedValue" id="forecastedValue">
                                                                        {edit ? <Input disabled prefix={currencySettings?.symbol} /> : <span >{currencySettings?.symbol} {displayData?.forecasted_value?.toLocaleString()}</span>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Expected Closure Date" name="expectedClosureDate"
                                                                        id="expectedClosureDate"
                                                                        rules={pipeLineField !== "Prospecting" && edit ? [{ required: true, message: 'Please select a closure date', }, ({ getFieldValue }) => ({
                                                                            validator(_, value) {
                                                                                const startDate = getFieldValue('revenueStartDate');
                                                                                if (!value || !startDate || value.isSameOrBefore(startDate, 'day')) {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                return Promise.reject(new Error('Expected Closure Date cannot be later than Revenue Start Date'));
                                                                            },
                                                                        }),] : [{ required: false }, ({ getFieldValue }) => ({
                                                                            validator(_, value) {
                                                                                const startDate = getFieldValue('revenueStartDate');
                                                                                if (!value || !startDate || value.isSameOrBefore(startDate, 'day')) {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                return Promise.reject(new Error('Expected Closure Date cannot be later than Revenue Start Date'));
                                                                            },
                                                                        }),]}
                                                                    >
                                                                        {edit ? <DatePicker
                                                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                            value={expectedClosureDate ? moment(expectedClosureDate, "YYYY-MM-DD") : null}
                                                                            onChange={expectedClosureDateChange}
                                                                            disabledDate={(current) => {
                                                                                const start = revenueStartDate ? moment(revenueStartDate, "YYYY-MM-DD").startOf("day") : null;
                                                                                const end = revenueEndDate ? moment(revenueEndDate, "YYYY-MM-DD").startOf("day") : null;

                                                                                return current && (
                                                                                    current < moment().startOf("day") || // ❌ disallow past
                                                                                    (start && current.isAfter(start, 'day')) || // ❌ disallow after start
                                                                                    (end && current.isAfter(end, 'day')) // ❌ disallow after end
                                                                                );
                                                                            }}
                                                                        /> : <>
                                                                            <span className='text_icon'>
                                                                                {displayData?.expected_closure_date && profile.dateFormate ? moment(displayData?.expected_closure_date).format(profile.dateFormate) : (displayData?.expected_closure_date && moment(displayData?.expected_closure_date).format("YYYY-MM-DD"))}
                                                                            </span>
                                                                        </>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Revenue Start date" name="revenueStartDate"
                                                                        id="revenueStartDate" rules={pipeLineField !== "Prospecting" &&
                                                                            dealTypeField !== "Empanelment" &&
                                                                            (edit || editWon) ?
                                                                            [{ required: true, message: 'Please enter revenue start date' },
                                                                            ({ getFieldValue }) => ({
                                                                                validator(_, value) {
                                                                                    const closure = getFieldValue('expectedClosureDate');
                                                                                    const end = getFieldValue('revenueEndDate');

                                                                                    if (!value) return Promise.resolve();

                                                                                    if (closure && value.isBefore(closure, 'day')) {
                                                                                        return Promise.reject(new Error('Revenue Start Date cannot be before the Expected Closure Date'));
                                                                                    }
                                                                                    if (end && value.isAfter(end, 'day')) {
                                                                                        return Promise.reject(new Error('Revenue start date must be before the revenue end date'));
                                                                                    }

                                                                                    return Promise.resolve();
                                                                                },
                                                                            }),
                                                                            ] : [{ required: false }, ({ getFieldValue }) => ({
                                                                                validator(_, value) {
                                                                                    const closure = getFieldValue('expectedClosureDate');
                                                                                    const end = getFieldValue('revenueEndDate');

                                                                                    if (!value) return Promise.resolve();

                                                                                    if (closure && value.isBefore(closure, 'day')) {
                                                                                        return Promise.reject(new Error('Revenue Start Date cannot be before the Expected Closure Date'));
                                                                                    }
                                                                                    if (end && value.isAfter(end, 'day')) {
                                                                                        return Promise.reject(new Error('Revenue start date must be before the revenue end date'));
                                                                                    }

                                                                                    return Promise.resolve();
                                                                                },
                                                                            }),]}>
                                                                        {edit || editWon ?
                                                                            <DatePicker onChange={revenueStartDateChange}
                                                                                format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                                disabledDate={(current) => {
                                                                                    const closure = expectedClosureDate ? moment(expectedClosureDate, "YYYY-MM-DD").startOf("day") : null;
                                                                                    const end = revenueEndDate ? moment(revenueEndDate, "YYYY-MM-DD").startOf("day") : null;

                                                                                    return current && (
                                                                                        current < moment().startOf("day") || // disallow past
                                                                                        (closure && current.isBefore(closure, 'day')) || // ✅ allow same as closure
                                                                                        (end && current.isAfter(end, 'day'))             // ✅ allow same as end
                                                                                    );
                                                                                }}
                                                                                disabled={typeAction === "Staff Augmentation"}
                                                                            /> : <>
                                                                                <span className='text_icon'>
                                                                                    {displayData?.revenue_start_date && profile.dateFormate ? moment(displayData?.revenue_start_date).format(profile.dateFormate) : (displayData?.revenue_start_date && moment(displayData?.revenue_start_date).format("YYYY-MM-DD"))}
                                                                                </span>
                                                                            </>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Revenue End Date" name="revenueEndDate"
                                                                        id="revenueEndDate" rules={pipeLineField !== "Prospecting" && dealTypeField !== "Empanelment" && (edit || editWon) ? [{ required: true, message: 'Please enter revenue end date' },
                                                                        ({ getFieldValue }) => ({
                                                                            validator(_, value) {
                                                                                const start = getFieldValue('revenueStartDate');
                                                                                if (!value || !start || value.isSameOrAfter(start, 'day')) {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                return Promise.reject(new Error('Revenue End Date cannot be before the Revenue Start Date'));
                                                                            },
                                                                        }),
                                                                        ] : [{ required: false }, ({ getFieldValue }) => ({
                                                                            validator(_, value) {
                                                                                const start = getFieldValue('revenueStartDate');
                                                                                if (!value || !start || value.isSameOrAfter(start, 'day')) {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                return Promise.reject(new Error('Revenue End Date cannot be before the Revenue Start Date'));
                                                                            },
                                                                        }),]}>
                                                                        {edit || editWon ? <DatePicker onChange={revenueEndDateChange} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                            disabledDate={(current) => {
                                                                                const start = revenueStartDate ? moment(revenueStartDate, "YYYY-MM-DD").startOf("day") : null;
                                                                                const closure = expectedClosureDate ? moment(expectedClosureDate, "YYYY-MM-DD").startOf("day") : null;

                                                                                return current && (
                                                                                    current < moment().startOf("day") || // ❌ disallow past
                                                                                    (start && current.isBefore(start, 'day')) || // ❌ disallow before start
                                                                                    (closure && current.isBefore(closure, 'day')) // ❌ disallow before closure
                                                                                );
                                                                            }} disabled={typeAction === "Staff Augmentation"} /> : <>
                                                                            <span className='text_icon'>
                                                                                {displayData?.revenue_end_date && profile.dateFormate ? moment(displayData?.revenue_end_date).format(profile.dateFormate) : (displayData?.revenue_end_date && moment(displayData?.revenue_end_date).format("YYYY-MM-DD"))}
                                                                            </span>
                                                                        </>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label={`Gross Proposal Value (${currencySettings?.currency})`} name="grossdealValue" id="grossdealValue"
                                                                        rules={pipeLineField !== "Prospecting" && dealTypeField !== "Empanelment" && edit ? [{ required: true, message: 'Please enter gross proposal value' }, {
                                                                            validator: async (_, value) => {
                                                                                if (value === undefined || value === null || value === '') {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                // Strict numeric check (digits with optional 1 dot)
                                                                                const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                if (!basicNumberCheck.test(value)) {
                                                                                    return Promise.reject(new Error('Please enter a valid number'));
                                                                                }

                                                                                // Check decimal places (must be ≤ 2)
                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                if (!decimalRegex.test(value)) {
                                                                                    return Promise.reject(
                                                                                        new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                                    );
                                                                                }
                                                                            }
                                                                        }] : [{ required: false }, {
                                                                            validator: async (_, value) => {
                                                                                if (value === undefined || value === null || value === '') {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                // Strict numeric check (digits with optional 1 dot)
                                                                                const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                if (!basicNumberCheck.test(value)) {
                                                                                    return Promise.reject(new Error('Please enter a valid number'));
                                                                                }

                                                                                // Check decimal places (must be ≤ 2)
                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                if (!decimalRegex.test(value)) {
                                                                                    return Promise.reject(
                                                                                        new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                                    );
                                                                                }
                                                                            }
                                                                        }]}
                                                                    >
                                                                        {edit ? <Input
                                                                            placeholder='Enter Gross Proposal Value'
                                                                            prefix={currencySettings?.symbol}
                                                                            min={0}
                                                                            // allowClear
                                                                            disabled={((typeAction !== "Request for Proposal" && typeAction !== "Others") || dealValueEdit === "Disabled")}
                                                                            onChange={(e) => OndealvalueChange(e.target.value)}
                                                                        />
                                                                            : <span >{currencySettings?.symbol} {displayData && displayData?.gross_deal_value && displayData?.gross_deal_value.toLocaleString()}</span>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }} >
                                                                    <Form.Item label="Discount Percentage" name="discountvalue" id="discountvalue" rules={[
                                                                        {
                                                                            validator: async (_, value) => {
                                                                                if (value === undefined || value === null || value === '') {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                // Strict numeric check (digits with optional 1 dot)
                                                                                const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                if (!basicNumberCheck.test(value)) {
                                                                                    return Promise.reject(new Error('Please enter a valid number'));
                                                                                }

                                                                                // Check decimal places (must be ≤ 2)
                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                if (!decimalRegex.test(value)) {
                                                                                    return Promise.reject(
                                                                                        new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                                    );
                                                                                }

                                                                                const num = Number(value); // Now it's guaranteed to be a proper number

                                                                                if (num < 0 || num > 100) {
                                                                                    return Promise.reject(new Error('Percentage must be between 0 and 100'));
                                                                                }

                                                                                return Promise.resolve();
                                                                            }

                                                                        }
                                                                    ]}>
                                                                        {edit ? <Input prefix="%" placeholder='Enter Discount Percentage' value={dealDiscount}
                                                                            onChange={(e) => setDealDiscount(e.target.value)} onBlur={(e) => {
                                                                                if (e.target.value === '') {
                                                                                    form.setFieldsValue({ discountvalue: 0 });
                                                                                    setDealDiscount(0);
                                                                                }
                                                                            }} />
                                                                            : <>
                                                                                <span >% {displayData?.discount_percentage}</span>
                                                                            </>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }} >
                                                                    <Form.Item label={`Proposal Value (${currencySettings?.currency})`} name="dealValue" id="dealValue" rules={[
                                                                        {
                                                                            pattern: /^\d+(\.\d+)?$/,
                                                                            message: 'Please enter a valid proposal value',
                                                                        },
                                                                    ]}>
                                                                        {edit ? <Input
                                                                            pattern="^\d+(\.\d+)?$"
                                                                            placeholder='Proposal Value'
                                                                            prefix={currencySettings?.symbol}
                                                                            disabled />
                                                                            : <span >
                                                                                {currencySettings?.symbol} {displayData && displayData?.deal_value && displayData?.deal_value.toLocaleString()}
                                                                            </span>}
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }} >
                                                                    <Form.Item label={`Proposal Profit (${currencySettings?.currency})`} name="dealprofit" id="dealprofit" rules={[
                                                                        {
                                                                            pattern: /^\d+(\.\d+)?$/,
                                                                            message: 'Please enter a valid proposal profit',
                                                                        },
                                                                    ]}>
                                                                        {edit ? <Input
                                                                            pattern="^\d+(\.\d+)?$"
                                                                            placeholder='Proposal Value'
                                                                            prefix={currencySettings?.symbol}
                                                                            disabled />
                                                                            : <span >
                                                                                {currencySettings?.symbol} {displayData && displayData?.deal_value && displayData?.deal_value.toLocaleString()}
                                                                            </span>}
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            {(pipeLineField === "Won" || pipeLineField === "Lost" || pipeLineField === "on-Hold" || pipeLineField === "On-Hold") ? <>
                                                                <Heading as="h5">Proposal {pipeLineField} Information</Heading>
                                                                <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                    {pipeLineField === "Won" && <>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Actual Closure Date" name="actualclosureDate"
                                                                                id="actualclosureDate"
                                                                                rules={pipeLineField === "Won" && dealTypeField !== "Empanelment" && edit ? [{ required: true, message: 'Please select actual closure date', }] : [{ required: false }]}
                                                                            >
                                                                                {edit ? <DatePicker onChange={actualclosuredateChange} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} disabledDate={disabledDate} />
                                                                                    : <span >
                                                                                        {displayData?.actual_closer_date && profile.dateFormate ? moment(displayData?.actual_closer_date).format(profile.dateFormate) : (displayData?.actual_closer_date && moment(displayData?.actual_closer_date).format("YYYY-MM-DD"))}
                                                                                    </span>}
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Actual Proposal Margin" name="actualdealmargin"
                                                                                id="actualdealmargin" rules={pipeLineField === "Won" && dealTypeField !== "Empanelment" && edit ? [{ required: true, message: 'Please select actual proposal margin' }, {
                                                                                    validator: async (_, value) => {
                                                                                        if (value === undefined || value === null || value === '') {
                                                                                            return Promise.resolve();
                                                                                        }
                                                                                        // Strict numeric check (digits with optional 1 dot)
                                                                                        const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                        if (!basicNumberCheck.test(value)) {
                                                                                            return Promise.reject(new Error('Please enter a valid number'));
                                                                                        }

                                                                                        // Check decimal places (must be ≤ 2)
                                                                                        const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                        if (!decimalRegex.test(value)) {
                                                                                            return Promise.reject(
                                                                                                new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                                            );
                                                                                        }

                                                                                        const num = Number(value); // Now it's guaranteed to be a proper number

                                                                                        if (num < 0 || num > 100) {
                                                                                            return Promise.reject(new Error('Percentage must be between 0 and 100'));
                                                                                        }

                                                                                        return Promise.resolve();
                                                                                    }

                                                                                }] : [{ required: false }]}>
                                                                                {edit ? <Input placeholder='Enter Actual Proposal Margin' prefix="%" onChange={(e) => setChangeDealMargin2(e.target.value)} />
                                                                                    : <span >% {displayData?.actual_deal_margin}</span>}
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Proposal Won Reason" name="dealWonreasons"
                                                                                id="dealWonreasons"
                                                                            >
                                                                                {edit ?
                                                                                    <Select style={{ width: '100%' }} placeholder="Select Proposal Won Reasons" onChange={(value) => form.setFieldsValue({ dealWonreasons: value || null })} allowClear>
                                                                                        {dealWon}
                                                                                    </Select>
                                                                                    : <span >{displayData?.dealWonReasonName}</span>}
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </>}
                                                                    {pipeLineField === "Lost" && <>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Proposal Lost Date" name="dealLostDate"
                                                                                id="dealLostDate"
                                                                                rules={pipeLineField === "Lost" && dealTypeField !== "Empanelment" && edit ? [{ required: true, message: 'Please select proposal lost date', }] : [{ required: false }]}>
                                                                                {edit ? <DatePicker
                                                                                    onChange={dealLostDateChange}
                                                                                    format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                                    disabledDate={disabledDate}
                                                                                />
                                                                                    : <span >
                                                                                        {displayData?.deal_lost_date && profile.dateFormate ? moment(displayData?.deal_lost_date).format(profile.dateFormate) : (displayData?.deal_lost_date && moment(displayData?.deal_lost_date).format("YYYY-MM-DD"))}
                                                                                    </span>}
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Proposal Lost Reason" name="deallostReasons" id="deallostReasons" >
                                                                                {edit ?
                                                                                    <Select style={{ width: '100%' }} onChange={(value) => form.setFieldsValue({ deallostReasons: value || null })} placeholder="Select Proposal Lost Reasons" allowClear>
                                                                                        {dealLose}
                                                                                    </Select>
                                                                                    : <span >{displayData?.dealLostReasonName}</span>}
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </>}
                                                                    {(pipeLineField === "on-Hold" || pipeLineField === "On-Hold") && <>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Proposal On-Hold Date" name="dealonholdDate"
                                                                                id="dealonholdDate"
                                                                                rules={(pipeLineField === "On-Hold" || pipeLineField === "on-Hold") && dealTypeField !== "Empanelment" && edit ? [{ required: true, message: 'Please select proposal On-hold date', }] : [{ required: false }]}>
                                                                                {edit ? <DatePicker onChange={dealonholdDateChange} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} disabledDate={disabledDate} />
                                                                                    : <span >
                                                                                        {displayData?.deal_hold_date && profile.dateFormate ? moment(displayData?.deal_hold_date).format(profile.dateFormate) : (displayData?.deal_hold_date && moment(displayData?.deal_hold_date).format("YYYY-MM-DD"))}
                                                                                    </span>}
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Proposal Restart Date" name="dealrestartDate"
                                                                                id="dealrestartDate" rules={[
                                                                                    ({ getFieldValue }) => ({
                                                                                        validator(_, value) {
                                                                                            const dealonholdDate = getFieldValue('dealonholdDate');

                                                                                            if (!value || !dealonholdDate || value >= dealonholdDate) {
                                                                                                return Promise.resolve();
                                                                                            }

                                                                                            return Promise.reject(new Error('Proposal Restart Date must be after Proposal onhold Date'));
                                                                                        },
                                                                                    }),]}>
                                                                                {edit ? <DatePicker onChange={dealrestartDateChange} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} disabledDate={disabledDate} />
                                                                                    : <span >
                                                                                        {displayData?.deal_restart_date && profile.dateFormate ? moment(displayData?.deal_restart_date).format(profile.dateFormate) : (displayData?.deal_restart_date && moment(displayData?.deal_restart_date).format("YYYY-MM-DD"))}
                                                                                    </span>}
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Proposal On-Hold Reason" name="dealonHoldReason" id="dealonHoldReason" >
                                                                                {edit ?
                                                                                    <Select style={{ width: '100%' }} placeholder="Select Proposal On-Hold Reasons" onChange={(value) => form.setFieldsValue({ dealonHoldReason: value || null })} allowClear>
                                                                                        {dealOnHold}
                                                                                    </Select>
                                                                                    : <span >{displayData?.dealOnholdReasonName}</span>}
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </>}
                                                                </Row>
                                                            </> : <></>}
                                                            {typeAction === "Staff Augmentation" ? <>
                                                                {(roleData.length > 0 || edit) &&
                                                                    <div style={{ display: 'flex' }}>
                                                                        <Heading as="h5">{!edit ? "Role Details" : "Add Roles"}</Heading>
                                                                        {/* {roleData.length === 0 && (revenueStartDate === null || revenueEndDate == null) && <span style={{ color: "red", margin: "1px 10px 0px" }}>* Please, Add Roles for Revenue start and End Date</span>} */}
                                                                    </div>}
                                                                {roleData.length ?
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={24} style={{ marginBottom: 20 }}>
                                                                            <div className={`table-bordered leaderboard-table table-responsive ${edit && 'Deal-RoleTable'}`}>
                                                                                <Table
                                                                                    dataSource={roleData}
                                                                                    columns={StaffColumns}
                                                                                    rowKey={(record, index) => index?.toString()}
                                                                                    pagination={false}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row> : <Row >{edit &&
                                                                        <PlusCircleOutlined
                                                                            title="Add New Staff Augmentation"
                                                                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "30px 0px" }}
                                                                            onClick={addNewRoles}
                                                                        />} </Row>}
                                                            </> : <></>}
                                                            {typeAction === "Product and Services" || typeAction === "Request for Proposal" ? <>
                                                                {(formDatas.length > 0 || edit) && <Heading as="h5">{!edit ? "Product Details" : "Add Products"}</Heading>}
                                                                {formDatas.length ?
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={24} style={{ marginBottom: 20 }}>
                                                                            <div className={`table-bordered leaderboard-table table-responsive ${edit && 'Product-DealTable'}`}>
                                                                                <Table
                                                                                    dataSource={formDatas}
                                                                                    columns={ProductColumns}
                                                                                    rowKey={(record, index) => index?.toString()}
                                                                                    pagination={false}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row> : <Row >{edit &&
                                                                        <PlusCircleOutlined
                                                                            title="Add New Product"
                                                                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "30px 0px" }}
                                                                            onClick={addNewRow}
                                                                        />} </Row>}
                                                            </> : <></>}
                                                            {typeAction === "Product and Services" || typeAction === "Request for Proposal" ? <>
                                                                {(servicesData.length > 0 || edit) && <Heading as="h5">{!edit ? "Service Details" : "Add Services"}</Heading>}
                                                                {servicesData.length ?
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={24} style={{ marginBottom: 20 }}>
                                                                            <div className={`table-bordered leaderboard-table table-responsive ${edit && 'Service-DealTable'}`}>
                                                                                <Table
                                                                                    dataSource={servicesData}
                                                                                    columns={ServicesColumns}
                                                                                    rowKey={(record, index) => index?.toString()}
                                                                                    pagination={false}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    : <Row>{edit &&
                                                                        <PlusCircleOutlined
                                                                            title="Add New Services"
                                                                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "30px 0px" }}
                                                                            onClick={addNewSerivce}
                                                                        />}</Row>}
                                                            </> : <></>}
                                                            <RelatedDocUpload edit={edit} FILEList={FILEList} setFileList={setFileList} form={form} />
                                                            <Heading as="h5">Profile Picture</Heading>
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <figure className="photoUpload align-center-v" >
                                                                        {image !== null && image !== undefined && image !== "" ?
                                                                            < img src={image} alt="" />
                                                                            :
                                                                            UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL" ?
                                                                                <span className='details_span_Tag DealIcon'>
                                                                                    {displayData?.deal_name?.slice(0, 1).toUpperCase()}
                                                                                </span>
                                                                                :
                                                                                <span className='details_span_Tag DealIcon'>
                                                                                    D
                                                                                </span>}
                                                                        {edit &&
                                                                            <figcaption>
                                                                                {deleteOption ? (
                                                                                    <div className='delete-div'>
                                                                                        <span className='delete-span'>
                                                                                            <FeatherIcon icon="trash-2" className="icon-svg" size={16} onClick={handleDeleteImage} />
                                                                                        </span>
                                                                                    </div>) :
                                                                                    (<div>
                                                                                        <ImgCrop aspect={1} cropShape="round" rotationSlider modalTitle="Crop Image">
                                                                                            <Upload {...FileUpload}>
                                                                                                <Link className="btn-upload" to={combinedUrl}>
                                                                                                    <FeatherIcon icon="camera" size={16} />
                                                                                                </Link>
                                                                                            </Upload></ImgCrop>
                                                                                    </div>)
                                                                                }
                                                                            </figcaption>
                                                                        }
                                                                    </figure>
                                                                </Col>
                                                            </Row>
                                                            {(UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL" && drawerPage !== "CloneDeal") && <>
                                                                <Heading as="h5">Other Information</Heading>
                                                                <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                                        <Form.Item label="Created Date" >
                                                                            <span >{displayData?.created_at}</span>
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                                        <Form.Item label="Created By" >
                                                                            <UploadUserTag record={{
                                                                                uploadedBy: `${displayData?.createdByFirstName} ${displayData?.createdByLastName}`,
                                                                                uploadedById: displayData?.createdBy,
                                                                                uploadedProfile: displayData?.createdByProfilePic
                                                                            }} />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                                        <Form.Item label="Modified Date" >
                                                                            <span >{displayData?.modified_at}</span>
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                                        <Form.Item label="Modified By" >
                                                                            <UploadUserTag record={{
                                                                                uploadedBy: `${displayData?.modifiedByFirstName} ${displayData?.modifiedByLastName}`,
                                                                                uploadedById: displayData?.modifiedBy,
                                                                                uploadedProfile: displayData?.modifiedByProfilePic
                                                                            }} />
                                                                        </Form.Item>
                                                                    </Col>
                                                                </Row >
                                                            </>}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </VerticalFormStyleWrap>
                                </BasicFormWrapper>
                            </Form>
                        </div>
                    </AddUser>
                </Scrollbars> :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Deal" getCallBack={getRefreshtheTable} />}
            <AddTaskPage UrlId={undefined} FromPage={createPageTask} setCratePage={setCreatePageTask} CallBackTrigger={setNaCTrigger} fromPageforTask="FromDetails" taskProp={taskProp} />
            <QuotesAdd UrlId={undefined} FromPage={createPageQuote} setCratePage={setCratePageQuote} dataForDeal={dataForQuote} CallBackTrigger={setNaCTrigger} />
            {/* {mailOpen && <ComposeMail mailOpen={mailOpen} close={closeMailComposr} entityName="Deals" entity="EntityPages" toId={displayData?.contactNames ? displayData?.contactNames?.map(contact => contact.contactPersonEmail) : []} />} */}
            <ComposeMail mailOpen={mailOpen} close={closeMailComposr} entityName="Deals" entity="EntityPages" toId={emailAttendees} AccountId={displayData?.account_id} CallBackTrigger={setNaCTrigger} entityUId={dealId} />
            {approveOpen && <Approvaldialog confirmPopup={approveOpen} setConfirmPopup={setApproveOpen} />}
            {sharePopup && <SharePopup sharePopup={sharePopup} setSharePopup={setSharePopup} sharingType="Deal" sharingIds={[dealId]} PageTypes="Single" />}
            {updatePopup && <Popup updatePopup={updatePopup} setUpdatePopup={setUpdatePopup} dealIDs={dealIDs} GetAll={getDetailsDatas} popupType={popupType} action={action} assignOwner={assignOwner} setDoubleClick={setDelteClick} loadingRef={loadingRef} deleteClick={deleteClick} />}
            {notePopup && <NotesPopup setNotePopup={setNotePopup} notePopup={notePopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} page={page} />}
            {callLogPopup && <CallLogPopup setCallLogPopup={setCallLogPopup} callLogPopup={callLogPopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} />}
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={pages} onNavigate={onnavigate} />}
            <MeetingLiPopup meetingOpen={meetingOpen} setMeetingOpen={setMeetingOpen} GetAll={getDetailsDatas} taskPage={taskPage} setNaCTrigger={setNaCTrigger} popupPageType="Create" meetingDate={formattedDate} meetingTime={formattedTime} Attendees={meetingAttendees} />
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
        </>
    );
}
AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    ShortCut: PropTypes.string.isRequired,
    dataForDeal: PropTypes.object.isRequired,
    CallBackTrigger: PropTypes.func.isRequired,
};
export default AddNew;